import {
    CdkDrag,
    CdkDragDrop,
    CdkDragStart,
    CdkDropList,
    DragDropModule,
    moveItemInArray,
} from '@angular/cdk/drag-drop';
import { CommonModule,formatCurrency,formatNumber,getCurrencySymbol } from '@angular/common';
import {
AfterViewInit,
ChangeDetectionStrategy,
Component,
DoCheck,
EventEmitter,
Inject,
Input,
LOCALE_ID,
OnDestroy,
OnInit,
Output,
QueryList,
ViewChild,
ViewChildren
} from '@angular/core';

import { FormArray,FormControl,FormsModule,ReactiveFormsModule,ɵFormGroupValue } from '@angular/forms';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatLegacyCheckboxModule as MatCheckboxModule } from '@angular/material/legacy-checkbox';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { MatLegacyInputModule as MatInputModule } from '@angular/material/legacy-input';
import { MatLegacyMenuModule as MatMenuModule } from '@angular/material/legacy-menu';
import { MatLegacySelectModule as MatSelectModule } from '@angular/material/legacy-select';
import { MatLegacySlideToggleModule } from '@angular/material/legacy-slide-toggle';
import { MatLegacyTable as MatTable,MatLegacyTableModule as MatTableModule } from '@angular/material/legacy-table';
import { MatLegacyTooltipModule as MatTooltipModule } from '@angular/material/legacy-tooltip';

import { MatSidenavModule } from '@angular/material/sidenav';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { Dictionary } from '@ngrx/entity';
import { Store } from '@ngrx/store';
import {
    BehaviorSubject,
    combineLatest,
    firstValueFrom,
    merge,
    Observable,
    of, ReplaySubject,
    Subject,
    Subscription,
    switchMap,
} from 'rxjs';
import {
    debounceTime,
    distinctUntilChanged,
    filter,
    first,
    map, pairwise,
    shareReplay,
    startWith,
    take,
    takeUntil,
    tap,
    withLatestFrom,
} from 'rxjs/operators';
import { CalculationInputComponent } from '../../../../calculation-input/calculation-input.component';
import {
AccountsReceivableLedgerEntity,
AccountsReceivableLedgerTypeEnum,
CalcAccountsReceivableLedgerBruttoAmountWithAllowances,
financialRound,
isBookingPositionTypeEnum,
QUANTITY_MAX_DECIMAL_PLACES
} from '../../../../dave-data-module/entities/accounts-receivable-ledger.entity';
import {
LedgerImportARLCalculationPreChargeByType,
LedgerImportDocumentTypes
} from '../../../../dave-data-module/entities/ledger-import.entity';
import { MaterialEntity } from '../../../../dave-data-module/entities/material.entity';
import { QuantityTypeEntity,QuantityTypeNames } from '../../../../dave-data-module/entities/quantity-type.entity';
import { ResourceEntity } from '../../../../dave-data-module/entities/resource-dispo/resource.entity';
import { SurchargeRateEntity } from '../../../../dave-data-module/entities/surcharge-rate.entity';
import {
AccountsReceivableLedgerPostType
} from '../../../../dave-data-module/graphql-types';
import { ArlDataService } from '../../../../dave-data-module/services/arl-data.service';
import { MaterialDataService } from '../../../../dave-data-module/services/material-data.service';
import { State } from '../../../../dave-data-module/State';
import {
getAccountsReceivableLedgerById,
getAccountsReceivableLedgersByIds,
getQuantityTypeDictionary,
getQuantityTypes
} from '../../../../dave-data-module/State/selectors/accounting.selector';
import { getJobSpecificationById } from '../../../../dave-data-module/State/selectors/job-specification.selector';
import {
    getLedgerImportById,
    getLedgerImportDictionary,
} from '../../../../dave-data-module/State/selectors/ledger-import.selector';
import { getDefaultVat } from '../../../../dave-data-module/State/selectors/partners.selectors';
import { getResourceById } from '../../../../dave-data-module/State/selectors/resource-dispo/resource.selectors';
import { DaveDoubleIconModule } from '../../../../dave-double-icon/dave-double-icon.module';
import { AppButtonModule } from '../../../../dave-utils-module/app-button-module/app-button.module';
import {
BreakpointObserverService
} from '../../../../dave-utils-module/dave-shared-components-module/services/breakpoint-observer.service';
import {
PermissionService
} from '../../../../dave-utils-module/dave-shared-components-module/services/permission.service';
import {
    compareArrays,
    getValueChangesObservableFromFormGroup,
    isNotNullOrUndefined, SearchQueriesDebounceTime, stringSearch,
    uniqArray,
} from '../../../../helper/helper';
import { IncludesPipe } from '../../../../helper/includes.pipe';
import { LengthPipe } from '../../../../helper/length.pipe';
import { MaterialPageMeta, ResourcePageMeta } from '../../../../helper/page-metadata';
import { decimalPriceValidator,getErrorMessage } from '../../../../helper/validation.helper';
import { NumberTransformInputComponent } from '../../../../number-transform-input/number-transform-input.component';
import { LoadingService } from '../../../../services/loading.service';
import { ArlInformationInputComponent } from '../../arl-information-input/arl-information-input.component';
import {
addArlDragButtonType,ArlTableComponentDisplayedColumns,ARL_TABLE_ALL_DISPLAYED_COLUMNS_SORTED,
ARL_TABLE_AUTO_COLUMN_HEADERS
} from '../../invoice-editor/invoice-editor.component';
import {
MaterialPriceDetailsPopupComponent,
MaterialPriceDetailsPopupComponentDialogData,
MaterialPriceDetailsPopupComponentDialogReturnData
} from '../../material-price-details-popup/material-price-details-popup.component';
import {
SelectSupplierDialogComponent,
SelectSupplierDialogData,SelectSupplierDialogReturnData
} from '../../select-supplier-dialog/select-supplier-dialog.component';
import { getAmountFromForm$ } from '../arl-amount-calculation-view/arl-table.helper';
import { ArlCalculationDataService } from '../arl-calculation-data.service';
import {
    arlFormUpdateQuantityByQuantityHistory,
    CalcAccountsReceivableLedgerBruttoBaseCostWithAllowancesCharges,
    CalcAccountsReceivableLedgerNettoBaseCostWithAllowancesCharges,
    calcPositionStrings, calculationArlGetBaseCostFromFormValue,
    formatPositionString, getARLCostAmountWithAllowance,
    getParents, invoiceEditorAutoScrollSpeed,
    switchHourMinute,
    switchHourMinuteCalc,
} from '../arl-calculation.helper';
import { ArlFormDataService,arlTableDataArlForm,getARLQuantityHistoryForm } from '../arl-form-data.service';
import {
ArlPositionDialogComponent,
ArlPositionDialogComponentDialogData,
ArlPositionDialogComponentDialogReturnData
} from '../arl-position-dialog/arl-position-dialog.component';
import { ArlTableDetailRowComponent } from '../arl-table-detail-row/arl-table-detail-row.component';
import { ArlTableService } from '../arl-table.service';
import {
    calculationArlForm,
    CalculationArlFormDataService,
    calculationArlFormGroup,
} from '../calculation-arl-form-data.service';
import {
QuantityHistoryModalComponent,
QuantityHistoryModalComponentDialogData,
QuantityHistoryModalComponentDialogReturnData
} from '../quantity-history-modal/quantity-history-modal.component';
import {
    MatLegacyPaginator,
    MatLegacyPaginatorIntl as MatPaginatorIntl,
    MatLegacyPaginatorModule,
} from '@angular/material/legacy-paginator';
import { HintIconComponent } from '../../../../hint-icon/hint-icon.component';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import {
    ArlTableCellBaseCostComponent
} from './cell-components/arl-table-cell-base-cost/arl-table-cell-base-cost.component';
import {
    ArlTableCellEditButtonComponent
} from './cell-components/arl-table-cell-edit-button/arl-table-cell-edit-button.component';
import {
    ArlTableCellInformationComponent
} from './cell-components/arl-table-cell-information/arl-table-cell-information.component';
import { ArlTablePositionHelperService } from './arl-table-position-helper.service';
import { ARLTableCalculationPosition, getCalculationArlCreatePayloadFromForm } from './arl-table-position-helper';
import { forEach, number } from 'mathjs';
import { MatPaginatorWrapperComponent } from '../../../../mat-paginator-wrapper/mat-paginator-wrapper.component';
import { GermanPaginatorIntl } from '../../../../services/german-paginator-intl.service';
import { SelectionModel } from '@angular/cdk/collections';
import { MatDividerModule } from '@angular/material/divider';
import { element } from 'protractor';
import {
    addTemplate
} from '../../../../dave-utils-module/dave-shared-components-module/components/template-dialog/template-dialog.component';
import { getCustomerDictionary } from '../../../../dave-data-module/State/selectors/customers.selectors';
import { CdkTableModule } from '@angular/cdk/table';
import { TableNavigationDirective } from '../../../../directives/table-navigation/table-navigation.directive';


export interface arlTableData<T = AccountsReceivableLedgerEntity> {
    entity: T;
    isExpanded$: Observable<boolean>;
    animationTrigger$: Observable<'collapsed' | 'expanded'>;
    calculatedAmount: FormControl<number>;
    amount$: Observable<number>;
    costAmount$: Observable<number>;
    amountWithTax$: Observable<number>;
    // position$: Observable<string>;
    resource$: Observable<ResourceEntity>;
    // material$: Observable<MaterialEntity>;
    form: arlTableDataArlForm;
    addQuantityHistoryForm: FormControl<number>;
    allowanceCount$: Observable<number>;
    chargeCount$: Observable<number>;
    chargeByTypeCount$: Observable<number>;
    baseCostSonstigesForm: FormControl<number>;
    // itemNumber: string;
    surchargePercentForm: FormControl<number>;
    // position: string;
    baseCostsWithAllowanceCharges$: Observable<{
        baseCostWithArlCharges: number | null;
        baseCostWithArlAllowanceCharges: number | null;
        baseCostGrossWithArlAllowanceCharges: number | null;
        salaryBaseCostWithArlCharges: number | null;
        salaryBaseCostWithArlAllowanceCharges: number | null;
        otherBaseCostWithArlCharges: number | null;
        otherBaseCostWithArlAllowanceCharges: number | null;
    }>;
    selectedQuantityTypeName$: Observable<string>;
    employeeCostSum$: Observable<number>;
    otherCostSum$: Observable<number>;
    percentDiff$: Observable<{
        employee: number
        other: number
        baseCost: number
    }>;
    baseCostCostSum$: Observable<number>;
    baseCostGrossCostSum$: Observable<number>;
    arlTableCalculationPositionHelper: null | ARLTableCalculationPosition;
    isBookingPosition$: Observable<boolean>;
}
export interface groupEndPlaceholder {
    currencyCode: string;
    groupId: number;
    amount$?: Observable<number>;
    amountWithTax$?: Observable<number>;
    amount?: number;
    information$: Observable<string>;
    isBookingPosition$: Observable<false>;
    costAmountVM$: Observable<{
        costAmount: number;
        costAmountGross: number;
        zs: number;
    } | null>;
}
export function determineIfIsArlTableDataOrGroupEnd<T = AccountsReceivableLedgerEntity>(toBeDetermined: arlTableData<T> | groupEndPlaceholder | any): toBeDetermined is arlTableData<T> {
    return !!(toBeDetermined as arlTableData<T>).entity;
}

export function getArlTypeIcon(type: AccountsReceivableLedgerTypeEnum): IconProp {
    switch (type) {
        case AccountsReceivableLedgerTypeEnum.Arl:
            return 'briefcase';
        case AccountsReceivableLedgerTypeEnum.ResourceArl:
            return ResourcePageMeta.Icon;
        case AccountsReceivableLedgerTypeEnum.MaterialArl:
            return MaterialPageMeta.Icon;
        case AccountsReceivableLedgerTypeEnum.ExternalService:
            return 'truck';
        case AccountsReceivableLedgerTypeEnum.EmployeeArl:
            return 'user-clock';
        case AccountsReceivableLedgerTypeEnum.Other:
            return 'shapes';
        case AccountsReceivableLedgerTypeEnum.Group:
            return 'layer-group';
        case AccountsReceivableLedgerTypeEnum.Text:
            return 't';
            default:
                return 'layer-group';
    }
}
@Component({
    selector: 'app-arl-table',
    standalone: true,
    imports: [
        CommonModule,
        DragDropModule,
        MatTableModule,
        FontAwesomeModule,
        MatCheckboxModule,
        MatButtonModule,
        AppButtonModule,
        MatTooltipModule,
        LengthPipe,
        ArlTableDetailRowComponent,
        MatInputModule,
        MatSelectModule,
        ReactiveFormsModule,
        NumberTransformInputComponent,
        // ArlInformationInputComponent,
        DaveDoubleIconModule,
        MatSidenavModule,
        MatMenuModule,
        FormsModule,
        IncludesPipe,
        MatLegacySlideToggleModule,
        CalculationInputComponent,
        // HintIconComponent,
        MatLegacyPaginatorModule,
        ArlTableCellBaseCostComponent,
        ArlTableCellEditButtonComponent,
        ArlTableCellInformationComponent,
        MatPaginatorWrapperComponent,
        MatDividerModule,
        CdkTableModule,
        // TableNavigationDirective,
        // HintIconComponent,
    ],
    templateUrl: './arl-table.component.html',
    styleUrls: ['./arl-table.component.scss'],
    providers: [ArlTablePositionHelperService, { provide: MatPaginatorIntl, useClass: GermanPaginatorIntl }],
    // animations: [trigger('detailExpand', [state('collapsed', style({ height: '0px', minHeight: '0' })), state('expanded', style({ height: '*' })), transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)'))])],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ArlTableComponent implements DoCheck, OnInit, OnDestroy, AfterViewInit {
    @ViewChild(MatLegacyPaginator) paginator: MatLegacyPaginator;
    // @ViewChild('drawer') drawer: MatDrawer;
    @ViewChild('tableDragList') tableDropList!: CdkDropList;
    @ViewChild('bookingPositionTable') bookingPositionTable: MatTable<any>;

    // @ViewChildren(ArlTableDetailRowComponent) private detailRows: QueryList<ArlTableDetailRowComponent>;
    expandedElement$ = new BehaviorSubject<number>(null);

    // @Output() selectedArlIdsChange = new EventEmitter<number[]>();
    private aRLCalculationPreChargeByTypes$ = new BehaviorSubject<LedgerImportARLCalculationPreChargeByType[]>([]);
    @Input() set ARLCalculationPreChargeByTypes(v: LedgerImportARLCalculationPreChargeByType[]) {
        if (JSON.stringify(this.aRLCalculationPreChargeByTypes$.value) !== JSON.stringify(v)) {
            // console.log('set ARLCalculationPreChargeByTypes', v);
            this.aRLCalculationPreChargeByTypes$.next(v);
        }
    }
    get ARLCalculationPreChargeByTypes(): LedgerImportARLCalculationPreChargeByType[] {
        return this.aRLCalculationPreChargeByTypes$.value;
    }
    private aRLCalculationPreCharge$ = new BehaviorSubject<number>(0);
    @Input() set aRLCalculationPreCharge(v: number) {
        if (v !== this.aRLCalculationPreCharge$.value) {
            this.aRLCalculationPreCharge$.next(v);
        }
    }
    get aRLCalculationPreCharge(): number {
        return this.aRLCalculationPreCharge$.value;
    }

    private readonly arlSurchargeByTypes$ = new ReplaySubject<{
        percentage: number
        arlType: AccountsReceivableLedgerTypeEnum
    }[]>(1);
    @Input() set ARLSurChargeByTypes(v: {
        percentage: number
        arlType: AccountsReceivableLedgerTypeEnum
    }[]) {
        this.arlSurchargeByTypes$.next(v);
    }

    @Input() AddARLDefaultValues: AccountsReceivableLedgerPostType;
    @Input() defaultSurcharges: Dictionary<SurchargeRateEntity>;
    @Input() qTypesDict: Dictionary<QuantityTypeEntity>;
    private filterMaterialsByCustomerId: number | null = null;
    @Input() set FilterMaterialsByCustomerId(v: number | null) {
        this.arlCalculationDataService.supplierIdFilterForOptions = v;
        this.filterMaterialsByCustomerId = v;
    }
    //@Input() isOrder = false;
    @Input() liDocumentType = LedgerImportDocumentTypes.Invoice;
    //@Input() isOffer = false;
    @Input() useListPriceForNewMaterials = false;
    // @Input() UseAmountFromMaterialToSupplier: boolean = false;

    protected useArlSeparateSalaryBaseCost$ = new BehaviorSubject(false);
    @Input() set useArlSeparateSalaryBaseCost(v: boolean) {
        if (!!v !== this.useArlSeparateSalaryBaseCost$.value) {
            this.useArlSeparateSalaryBaseCost$.next(!!v);
        }
    }
    @Input() forceQuantityTypeIdForEmployeeArls: number = null;
    // @Output() AddBookingPosition = new EventEmitter<number>();
    @Output() FormValueChange = new EventEmitter<void>();

    @Input() UseQuantityHistory = false;
    @Input() newArlBtnDragList!: CdkDropList<{ type: addArlDragButtonType; label: string }[]>;

    private formValueChangeSubscription: Subscription;
    // @Output() selectedGroupIdsChange = new EventEmitter<number[]>();
    _arlIds: number[] = null;
    _arlIds$ = new BehaviorSubject<number[]>([]);
    onDestroy$ = new Subject<void>();
    tableData2$: Observable<(arlTableData<AccountsReceivableLedgerEntity> | groupEndPlaceholder)[]> = this._arlIds$.pipe(
        takeUntil(this.onDestroy$),
        // distinctUntilChanged((a, b) => {
        //     console.log('vs', a, b);
        //     return JSON.stringify(a) === JSON.stringify(b);
        // }),
        tap((a) => console.log('JSON.stringify _arlIds$', JSON.stringify(a), 'JSON.stringify(this._arlIds)', JSON.stringify(this._arlIds))),
        filter((arlIds) => JSON.stringify(arlIds) !== JSON.stringify(this._arlIds)),
        tap((arlIds) => {
            console.log(' set this._arlIds to ', arlIds.slice());
            this._arlIds = arlIds.slice();
        }),
        switchMap((arlIds) =>
            arlIds?.length
                ? combineLatest(arlIds.map((id) => this.store.select(getAccountsReceivableLedgerById({ id })))).pipe(
                      // this.store.select(getAccountsReceivableLedgerDictionary).pipe(
                      // map(arls => arls.filter(isNotNullOrUndefined).reduce((p, c) => p[c.Id] = c, {})),
                      first(), // reparieren in dem die daten in eine map arlId => arlTable data in eine map in einem service ausgelagert werden, der auch bei Änderungen von außerhalb den kram aktualisiert. hier werden dann nur children gesucht und in richtige reihenfolge gebracht, dann mit filter auf aktuelle Reihenfolge die daten aus dem service dran gebaut
                      // withLatestFrom(this.store.select(getAccountsReceivableLedgerDictionary)), // todo fix das der store hier für alle triggert, da muss eigentlich alle arls by id abgerufen werden
                      withLatestFrom(this.arlDataService.selectAllArlsDict()),
                      map(([arlArray, allArls]) => {
                          console.group('create tableData2$');
                          const getArlChildrenTableData: (id: number) => (arlTableData<AccountsReceivableLedgerEntity> | groupEndPlaceholder)[] = (id: number) => {
                              const arl = allArls[id];
                              if (!arl) {
                                  console.error('arl not found, id; ' + id);
                                  return [];
                              }
                              // console.log('getArlChildrenTableData', id, arl);
                              const childArlIds = this.arlFormDataService.getForm(id)?.value.ARLIds || uniqArray(arl.ArlIds);
                              if (arl.Type === AccountsReceivableLedgerTypeEnum.Group) {
                                  const ret = [
                                      this.getArlTableData(arl, allArls),
                                      ...childArlIds
                                          .map(
                                              (i) => getArlChildrenTableData(i),
                                              // _getArlChildren(i)
                                              //     .map((a) => this.getArlTableData(a))
                                              //     .flat(),
                                          )
                                          .flat(),
                                      this.getGroupEnd(arl),
                                  ];
                                  console.log('ret', ret, childArlIds);
                                  return ret;
                              }
                              return [this.getArlTableData(arl, allArls)];
                          };
                          // this.arlFormDataService.clearAllForms(); todo rausfinden ob das so muss macht das schwierig weil dies ding getriggert wird wenn man eine neue arl (extern) hinzufügt
                          console.log(JSON.stringify(arlIds) /*arlArray*/);
                          console.log('##########');
                          const arlswithchildren = arlIds.map((id) => getArlChildrenTableData(id)).flat();
                          console.log({ arlIds, arlIdsParsed: JSON.stringify(arlIds), arlswithchildren });
                          if (arlswithchildren.some((arl, i) => determineIfIsArlTableDataOrGroupEnd(arl) && i !== arlswithchildren.findIndex((a) => determineIfIsArlTableDataOrGroupEnd(a) && a.entity.Id === arl.entity.Id))) {
                              console.log({ arlswithchildren });
                              throw 'arls doppelt zugewiesen';
                          }
                          console.groupEnd();
                          return arlswithchildren;
                      }),
                      // distinctUntilChanged(
                      //     (a, b) =>
                      //         a.length === b.length &&
                      //         a.every((e) => (determineIfIsArlTableDataOrGroupEnd(e) ? b.some((v) => determineIfIsArlTableDataOrGroupEnd(v) && v.entity.Id === e.entity.Id && v.entity.UpdatedAt === e.entity.UpdatedAt) : true)),
                      // ),
                  )
                : of([] as Array<arlTableData>),
        ),
        tap((a) => console.log('---tabledarta2$', a)),
        shareReplay(1),
    );
    protected logRender() {
        console.log('### render arl-table')
    }
    tableData$ = this.tableData2$.pipe(
        switchMap((data) =>
            this.arlIdsChange.pipe(
                map(() => data),
                startWith(data),
            ),
        ),
        tap((data) => {
            console.log('tableData$', data);
            this.bookingPositionTable?.renderRows();
        }),
        shareReplay({bufferSize: 1, refCount: true})
    );
    protected paginatedData$: Observable<(groupEndPlaceholder | arlTableData<AccountsReceivableLedgerEntity>)[]>
    public triggerPositionCalculation$ = new Subject<void>();
    private ignoreLockOnce = false;

    public triggerPositionCalculation(ignoreLock = false) {
        this.ignoreLockOnce = ignoreLock;
        this.triggerPositionCalculation$.next();
    }
    @Input() set arlIds(v: number[]) {
        console.log('set arlIds *****');
        console.log(v.slice(), this._arlIds?.slice());
        this._arlIds$.next(v.slice());
        // firstValueFrom(this.tableData2$).then(tableData => {
        //     if (tableData.some()) {
        //
        //     }
        //     this._arlIds$.next(v);
        // });
    }
    get arlIds() {
        return this._arlIds$.value;
    }
    @Output() arlIdsChange = new EventEmitter<any>();
    @Output() DeleteClick = new EventEmitter<number[]>();
    protected _disabled = false;
    @Input() set disabled(v: boolean) {
        if (this._disabled !== v) {
            this._disabled = v;
            // console.warn('*** set disavled', v);
            // firstValueFrom(this.tableData2$).then((td) => {
            //     if (this._disabled) {
            //         td.filter(determineIfIsArlTableDataOrGroupEnd).forEach((d) => this.disableForm(d.form));
            //     } else {
            //         td.filter(determineIfIsArlTableDataOrGroupEnd).forEach((d) => this.enableForm(d.form));
            //     }
            // });
        }
    }
    protected _itemNumbersLocked = false;
    @Input() set itemNumbersLocked(v: boolean) {
        if (this._itemNumbersLocked !== v) {
            this._itemNumbersLocked = v;
        }
    }
    get disabled() {
        return this._disabled;
    }
    // @Input() NewARLDefaultValues: DaveMutationCreateAccountsReceivableLedgerArgs;

    ngDoCheck$ = new Subject<void>();
    private someDetailRowDirty$: Observable<boolean>;
    private someFormDirtySubscription$: Subscription;
    public someFormDirty = false;
    @Output() someFormDirty$ = new EventEmitter<boolean>();
    public AllFormValueChanges$ = this.tableData$.pipe(switchMap((data) => merge(...data.filter(determineIfIsArlTableDataOrGroupEnd).map((d) => d.form.valueChanges))));
    protected LiDocumentType$ = new BehaviorSubject<LedgerImportDocumentTypes | null>(null);

    public readonly AutoColumnHeaders = ARL_TABLE_AUTO_COLUMN_HEADERS;

    public AutoColumnWithClass = {
        DragButton: '',
        Position: '',
        BookingText: '',
        Information: 'wide',
        Quantity: 'small',
        QuantityType: 'small',
        BaseCost: 'medium',
        BaseCost_salary: 'medium',
        BaseCost_other: 'medium',
        BaseCostGross: 'medium',
        CompleteCostGross: 'medium',
        CompleteCost: 'medium',
        BaseCost_salary_cost: 'medium',
        BaseCost_other_cost: 'medium',
        BaseCost_cost: 'medium',
        BaseCostGross_cost: 'medium',
        IsVisible: 'x-small-fix',
        InheritFromChildren: 'x-small-fix',
        EditButton: 'medium-fix',
    };
    protected displayedColumns$ = new BehaviorSubject<Array<ArlTableComponentDisplayedColumns>>(ARL_TABLE_ALL_DISPLAYED_COLUMNS_SORTED);
    @Input() set displayedColumns(value: Array<ArlTableComponentDisplayedColumns>) {
        if (Array.isArray(value) && !compareArrays(this.displayedColumns$.value, value)) {
            this.displayedColumns$.next(value);
        }
    }

    public allreadyCalculated: boolean = false;
    public allColumns$ = combineLatest([this.bs.MobileQuery, this.useArlSeparateSalaryBaseCost$]).pipe(
        map(([mobile, useArlSeparateSalaryBaseCost]) => {
            if (!mobile) {
                return [
                    'DragButton',
                    ...ARL_TABLE_ALL_DISPLAYED_COLUMNS_SORTED.filter((col) => useArlSeparateSalaryBaseCost || (col !== 'BaseCost_salary' && col !== 'BaseCost_other' && col !== 'BaseCost_salary_cost' && col !== 'BaseCost_other_cost')),
                    'EditButton',
                    'IsVisible',
                    'InheritFromChildren',
                ].filter(isNotNullOrUndefined);
            } else {
                return ['DragButton', 'Information', 'CompleteCost', 'EditButton'];
            }
        }),
    );

    DisplayedColumns$ = combineLatest([this.displayedColumns$, this.bs.MobileQuery, this.useArlSeparateSalaryBaseCost$]).pipe(
        map(([cols, mobile, useArlSeparateSalaryBaseCost]) => {
            if (!mobile) {
                return ['DragButton', ...cols.filter((col) => useArlSeparateSalaryBaseCost || (col !== 'BaseCost_salary' && col !== 'BaseCost_other' && col !== 'BaseCost_salary_cost' && col !== 'BaseCost_other_cost')), 'IsVisible', 'InheritFromChildren', 'EditButton'].filter(isNotNullOrUndefined);
            } else {
                return ['DragButton', 'Information', 'CompleteCost', 'EditButton'];
            }
        }),
    );
    // DisplayedColumns$ = combineLatest([this.bs.MobileQuery, this.showBruttoColumn$]).pipe(
    //     map(([mobile, showBruttoColumn]) => {
    //         if (!mobile) {
    //             return [
    //                 'DragButton',
    //                 'Position',
    //                 'BookingText',
    //                 'Information',
    //                 'Quantity',
    //                 'QuantityType',
    //                 'BaseCost',
    //                 'CompleteCost',
    //                 showBruttoColumn ? 'CompleteCostWithoutTax' : null,
    //                 'IsVisible',
    //                 'InheritFromChildren',
    //                 'EditButton',
    //             ].filter(isNotNullOrUndefined);
    //         } else {
    //             return ['DragButton', 'Information', 'CompleteCost', 'EditButton'];
    //         }
    //     }),
    // );

    // private triggerPositionChange(newPosition: arlTableData<AccountsReceivableLedgerEntity>) {
    //     newPosition.form.controls.ItemNumber.setValue(newPosition.itemNumber, {emitEvent: false});
    //     newPosition.form.controls.ItemNumber.markAsDirty();
    // }

    positionRecalculationSub: Subscription;
    determineIfIsArlTableDataOrGroupEnd = determineIfIsArlTableDataOrGroupEnd;
    getArlTypeIcon = getArlTypeIcon;
    protected isInvalidDragEvent = true;
    // scope$ = this.mathJsCustomScopeService.scope$;

    protected length$ = this.tableData$.pipe(
        map((data) => data.length),
    );

    public selection = new SelectionModel<number>(true, []);
    protected selectionDataChanged$ = new Subject<void>();
    public selectionData$ = merge(this.selection.changed, this.selectionDataChanged$).pipe(
        startWith(null),
        // tap(s => console.log('### selection changed', s)),
        map(() => {
            const allChildrensIncludedInSelection = (form: arlTableDataArlForm, arlIds: number[]) => {
                return arlIds.includes(form.controls.Id.getRawValue()) && form.controls.childArls.controls.every(childForm => allChildrensIncludedInSelection(childForm, arlIds));
            }
            return {
                empty: this.selection.isEmpty(),
                length: this.selection.selected.length,
                someCrossedOut: this.selection.selected.some(arlId => this.arlFormDataService.getForm(arlId).controls.CrossedOut.value === true),
                someCanBeCrossedOut: this.selection.selected.some(arlId => this.arlFormDataService.getForm(arlId).controls.CrossedOut.value === false),
                someOptional: this.selection.selected.some(arlId => this.arlFormDataService.getForm(arlId).controls.IsOptional.value === true),
                someCanBeOptional: this.selection.selected.some(arlId => this.arlFormDataService.getForm(arlId).controls.IsOptional.value === false),
                someCanBeFrozen: this.selection.selected.some(arlId => {
                    const form = this.arlFormDataService.getForm(arlId);
                    return isBookingPositionTypeEnum(form.controls.Type.value) && form.controls.FixedPrices.value === false
                }),
                someFrozen: this.selection.selected.some(arlId => {
                    const form = this.arlFormDataService.getForm(arlId);
                    return isBookingPositionTypeEnum(form.controls.Type.value) && form.controls.FixedPrices.value === true
                }),
                canCopy: !this.selection.isEmpty() && this.selection.selected.every(arlId => {
                    const form = this.arlFormDataService.getForm(arlId);
                    return allChildrensIncludedInSelection(form, this.selection.selected);
                }),
                canSplit: !this.selection.isEmpty() && this.selection.selected.every(arlId => {
                    const form = this.arlFormDataService.getForm(arlId);
                    return form.controls.childArlsCalculation.length > 0;
                }),
                canMerge: this.selection.selected.length > 1 && this.selection.selected.every(arlId => {
                    const form = this.arlFormDataService.getForm(arlId);
                    return form.controls.childArlsCalculation.length === 0 && form.controls.childArls.length === 0;
                }),
            }
        })
    );
    private selectableTableData$: Observable<arlTableData<AccountsReceivableLedgerEntity>[]> = this.tableData$.pipe(map(td => td.map<arlTableData<AccountsReceivableLedgerEntity>>(t => determineIfIsArlTableDataOrGroupEnd(t) ? t : null).filter(t => t !== null)));
    protected mainCheckboxData$ = combineLatest([this.selectionData$, this.selectableTableData$]).pipe(
        map(([selectionData, tableData]) => {
            console.log(
                {
                    allSelected: selectionData.length === tableData.length,
                    indeterminate: selectionData.length > 0 && selectionData.length < tableData.length,
                    selectionData,
                    tableData,
                }
            )
            return {
                allSelected: selectionData.length === tableData.length,
                indeterminate: selectionData.length > 0 && selectionData.length < tableData.length
            };
        })
    );
    protected _multiselectActive = false;
    @Input() set multiselectActive(val: boolean) {
        this.setMultiselectActive(val, false);
    }
    @Output() multiselectActiveChange = new EventEmitter<boolean>();


    public searchQuery$ = new BehaviorSubject<string | null>(null);
    @Input() set searchQuery(searchQuery: string | null) {
        console.log('searchQuery', searchQuery);
        if (searchQuery !== this.searchQuery$.value) {
            this.searchQuery$.next(searchQuery);
        }
    }

    constructor(
        public bs: BreakpointObserverService,
        public PS: PermissionService,
        @Inject(LOCALE_ID) public locale: string,
        private store: Store<State>,
        protected arlCalculationDataService: ArlCalculationDataService,
        protected ls: LoadingService,
        private arlDataService: ArlDataService,
        private arlFormDataService: ArlFormDataService,
        private calculationArlFormDataService: CalculationArlFormDataService,
        private materialDataService: MaterialDataService,
        private dialog: MatDialog,
        public LS: LoadingService,
        private arlTableService: ArlTableService,
        private arlTablePositionHelperService: ArlTablePositionHelperService
        // private mathJsCustomScopeService: MathJsCustomScopeService,
    ) {}

    ngOnDestroy(): void {
        this.formValueChangeSubscription.unsubscribe();
        this.someFormDirtySubscription$?.unsubscribe();
        this.positionRecalculationSub?.unsubscribe();
        this.onDestroy$.next();
    }

    ngOnInit(): void {
        this.formValueChangeSubscription = this.AllFormValueChanges$.subscribe((v) => {
            // console.log('ValueChanged');
            this.FormValueChange.emit();
        });

        this.store
            .select(getLedgerImportById({ id: this.AddARLDefaultValues.ledgerImportId }))
            .pipe(
                take(1),
                tap((li) => {
                    this.LiDocumentType$.next(li.DocumentType);
                    // this._disabled = !!(li?.GaebfromVersionId || (li?.GaebExportedDocumentIds && Object.keys(li?.GaebExportedDocumentIds).length !== 0));
                    this._itemNumbersLocked = li?.ItemNumbersLocked ?? false;
                }),
            )
            .subscribe();
        this.positionRecalculationSub = combineLatest([this.tableData$, this.triggerPositionCalculation$.pipe(startWith(null))]).subscribe(([tableData, _]) => {
            if(this._itemNumbersLocked && !this.ignoreLockOnce){
                this.allreadyCalculated = false;
            }

            const positions = calcPositionStrings(
                tableData,
                determineIfIsArlTableDataOrGroupEnd,
                (v) => !determineIfIsArlTableDataOrGroupEnd(v),
                (v) => determineIfIsArlTableDataOrGroupEnd(v) && v.entity.Type === AccountsReceivableLedgerTypeEnum.Group,
                (v) => (determineIfIsArlTableDataOrGroupEnd(v) ? v.form.controls.ItemNumber.value : null),
                this.allreadyCalculated,
                this.ignoreLockOnce
            );
            const positionIdMap = new Map<number, string>();
            if (positions.length === 0){
                return positionIdMap;
            }
            console.log('triggerPositionChange', positions);
            tableData.forEach((v, i) => {
                if (determineIfIsArlTableDataOrGroupEnd(v)) {
                    const paddedParts = positions[i]?.split('.').filter((part) => part !== '');
                    //    const entityParts = (v.entity.ItemNumber ?? '').split('.');

                    let pos = v.entity.ItemNumber !== null || this.ignoreLockOnce ?  (this.allreadyCalculated ? formatPositionString(positions[i]) : positions[i]) :  paddedParts ? paddedParts.join('.') + '.' : null;

                    positionIdMap.set(v.entity.Id, (v.entity.ItemNumber !== null || this.ignoreLockOnce ) ? pos : '');
                    // v.itemNumber = pos;

                    if (v.form.controls.ItemNumber.value !== pos && v.entity.ItemNumber !== null) {
                        // console.log('triggerPositionChange', v.form.controls.ItemNumber.value, pos);
                        // this.triggerPositionChange(v);
                        v.form.controls.ItemNumber.markAsDirty();
                        v.form.controls.ItemNumber.setValue(pos);
                    }
                }
            });
            console.log({ positions, positionIdMap, tableData });
            this.allreadyCalculated = true;
            this.ignoreLockOnce = false;
            // return positionIdMap;
        });
    }
    ngAfterViewInit() {
        // this.SomeFormDirty$ = of(false);
        let pageIndexCache = this.paginator.pageIndex;
        let pageSizeCache = this.paginator.pageSize;
        const filteredData$ = this.tableData$.pipe(
            switchMap((data) => this.searchQuery$.pipe(
                debounceTime(SearchQueriesDebounceTime),
                startWith(''),
                map(() => (this.searchQuery$.value || '').trim().toLocaleLowerCase()),
                distinctUntilChanged(),
                pairwise(),
                startWith(''),
                withLatestFrom(this.store.select(getCustomerDictionary)),
                map(([[prevSearchQuery, searchQuery], customerDictionary]) => {

                    if (searchQuery && !prevSearchQuery) {
                        pageIndexCache = this.paginator.pageIndex;
                        pageSizeCache = this.paginator.pageSize;
                        this.paginator.firstPage();
                    } else if (!searchQuery && prevSearchQuery) {
                        this.paginator.pageSize = pageSizeCache;
                        this.paginator.pageIndex = pageIndexCache;
                    }
                    if (!searchQuery) {
                        return data;
                    }
                    return data.filter((arlTableData) => determineIfIsArlTableDataOrGroupEnd(arlTableData) && (arlTableData.form.controls.ItemNumber.getRawValue()?.toLowerCase().startsWith(searchQuery) || [arlTableData.form.controls.Information.getRawValue(), arlTableData.form.controls.BookingText.getRawValue()].some(s => stringSearch(s, searchQuery)) || (arlTableData.form.controls.SupplierId.getRawValue() && stringSearch(customerDictionary[arlTableData.form.controls.SupplierId.getRawValue()]?.Name, searchQuery)) ))
                }),

                )
            ),
        );
        this.paginatedData$ = combineLatest([
            filteredData$,
            this.paginator.page.pipe(startWith(null)),
        ]).pipe(
            map(([data, _]) => data.slice(this.paginator.pageIndex * this.paginator.pageSize, (this.paginator.pageIndex + 1) * this.paginator.pageSize)),
        )
        this.someDetailRowDirty$ = this.tableData$.pipe(
            map(tableRows => tableRows.filter(determineIfIsArlTableDataOrGroupEnd).filter(r => r.arlTableCalculationPositionHelper)),
            switchMap((tableRows) => (tableRows.length ? combineLatest(tableRows.map((r) => r.arlTableCalculationPositionHelper.arlFormsDirty$)) : of([] as boolean[]))),
            map((v) => v.some((d) => !!d)),
            tap((dirty) => console.log('someDetailRowDirty$', dirty)),
        );
        // this.someDetailRowDirty$ = this.bookingPositionTable.contentChanged.pipe(
        //     startWith(null),
        //     switchMap(() => (this.detailRows.length ? combineLatest(this.detailRows.map((r) => r.someFormDirty$)) : of([]))),
        //     map((v) => v.some((d) => !!d)),
        //     tap((dirty) => console.log('someDetailRowDirty$', dirty)),
        // );
        this.someFormDirtySubscription$ = combineLatest([this.tableData2$, this.bookingPositionTable.contentChanged.pipe(startWith(null))])
            .pipe(
                switchMap(([data, _]) =>
                    data.length
                        ? combineLatest([
                              this.someDetailRowDirty$,
                              this.ngDoCheck$.pipe(
                                  startWith(null),
                                  map(() => {
                                      const ret = data.some((d) => determineIfIsArlTableDataOrGroupEnd(d) && d.form.dirty);
                                      // console.log('invoice-editor-dirty-debug: arlTable dirty', ret, data.filter((d) => determineIfIsArlTableDataOrGroupEnd(d) && d.form.dirty));
                                      return ret;
                                  }),
                              ),
                          ]).pipe(map((f) => f.some((v) => !!v)))
                        : of(false),
                ),
                distinctUntilChanged(),
            )
            .subscribe((dirty) => {
                this.someFormDirty = dirty;
                this.someFormDirty$.emit(dirty);
            });
    }

    async getArlCalculationForms(): Promise<Map<number, Array<ɵFormGroupValue<calculationArlForm> & { getBaseCost: () => number }>>> {
        const rows = await firstValueFrom(this.tableData2$);
        const filteredRows = rows.filter(determineIfIsArlTableDataOrGroupEnd).filter(r => r.arlTableCalculationPositionHelper);
        const map = new Map<number, Array<ɵFormGroupValue<calculationArlForm> & { getBaseCost: () => number }>>([]);
        if (filteredRows.length) {
            const forms = await Promise.all(filteredRows.map((d) => d.arlTableCalculationPositionHelper.getChildFormValues()));
            filteredRows.forEach((d, i) => {
                if (forms[i]) {
                    map.set(d.entity.Id, forms[i]);
                }
            });
        }
        return map;
        // const forms = await Promise.all(rows.filter(determineIfIsArlTableDataOrGroupEnd).map((d) => d.arlTableCalculationPositionHelper.getChildFormValues()));
        // // combineLatest(this.detailRows.map((d) => d.arlCalculationViewComponent.getChildFormValues()))
        // return firstValueFrom(this.detailRows.length ? combineLatest(this.detailRows.map((d) => d.arlCalculationViewComponent.getChildFormValues())) : of([])).then((forms) => {
        //     const map = new Map<number, Array<ɵFormGroupValue<calculationArlForm> & { getBaseCost: () => number }>>([]);
        //     this.detailRows.forEach((d, i) => {
        //         if (forms[i]) {
        //             map.set(d.arl.Id, forms[i]);
        //         }
        //     });
        //     return map;
        // });
    }
    private getGroupEnd = (e: AccountsReceivableLedgerEntity): groupEndPlaceholder => {
        const form = this.arlFormDataService.getForm(e.Id);
        if (!form) {
            throw 'form not found ' + e.Id;
        }
        const arlsBetween$ = this.tableData$.pipe(
            map((tableData) => {
                let a = false;
                const ret: Array<arlTableData<AccountsReceivableLedgerEntity>> = [];
                tableData.forEach((td) => {
                    if (determineIfIsArlTableDataOrGroupEnd(td) && td.entity.Id === e.Id) {
                        a = true;
                    } else if (!determineIfIsArlTableDataOrGroupEnd(td) && td.groupId === e.Id) {
                        a = false;
                    }
                    if (a && determineIfIsArlTableDataOrGroupEnd(td) && td.entity.Type !== AccountsReceivableLedgerTypeEnum.Group) {
                        ret.push(td);
                    }
                });
                return ret;
            })
        );
        const amount$ = arlsBetween$.pipe(
            switchMap((tableData) => {
                const sum: Observable<number>[] = [];
                tableData.forEach((td) => {
                    sum.push(
                        td.amount$.pipe(
                            switchMap((amount) =>
                                combineLatest([
                                    td.form.controls.IsOptional.valueChanges.pipe(
                                        startWith(null),
                                        map(() => td.form.controls.IsOptional.getRawValue()),
                                    ),
                                    td.form.controls.CrossedOut.valueChanges.pipe(
                                        startWith(null),
                                        map(() => td.form.controls.CrossedOut.getRawValue()),
                                    ),
                                ]).pipe(map(([optional, crossed]) => (optional || crossed ? 0 : amount))),
                            ),
                        ),
                    );
                });
                return sum.length ? combineLatest(sum).pipe(map((amounts) => amounts.reduce((p, c) => p + (c || 0), 0))) : of(0);
            }),
        );

        const costAmount$ = arlsBetween$.pipe(
            switchMap((tableData) => {
                const sum: Observable<number>[] = [];
                tableData.forEach((td) => {
                    sum.push(
                        td.costAmount$.pipe(
                            switchMap((cost) =>
                                combineLatest([
                                    td.form.controls.IsOptional.valueChanges.pipe(
                                        startWith(null),
                                        map(() => td.form.controls.IsOptional.getRawValue()),
                                    ),
                                    td.form.controls.CrossedOut.valueChanges.pipe(
                                        startWith(null),
                                        map(() => td.form.controls.CrossedOut.getRawValue()),
                                    ),
                                ]).pipe(map(([optional, crossed]) => (optional || crossed ? 0 : cost))),
                            ),
                        ),
                    );
                });
                return sum.length ? combineLatest(sum).pipe(map((amounts) => amounts.reduce((p, c) => p + (c || 0), 0))) : of(0);
            }),
        );
        const amountWithTax$ = this.tableData$.pipe(
            switchMap((tableData) => {
                const sum: Observable<number>[] = [];
                let a = false;
                tableData.forEach((td) => {
                    if (determineIfIsArlTableDataOrGroupEnd(td) && td.entity.Id === e.Id) {
                        a = true;
                    } else if (!determineIfIsArlTableDataOrGroupEnd(td) && td.groupId === e.Id) {
                        a = false;
                    }
                    if (a && determineIfIsArlTableDataOrGroupEnd(td) && td.entity.Type !== AccountsReceivableLedgerTypeEnum.Group) {
                        sum.push(
                            td.amountWithTax$.pipe(
                                switchMap((amount) =>
                                    combineLatest([
                                        td.form.controls.IsOptional.valueChanges.pipe(
                                            startWith(null),
                                            map(() => td.form.controls.IsOptional.getRawValue()),
                                        ),
                                        td.form.controls.CrossedOut.valueChanges.pipe(
                                            startWith(null),
                                            map(() => td.form.controls.CrossedOut.getRawValue()),
                                        ),
                                    ]).pipe(map(([optional, crossed]) => (optional || crossed ? 0 : amount))),
                                ),
                            ),
                        );
                    }
                });
                return sum.length ? combineLatest(sum).pipe(map((amounts) => amounts.reduce((p, c) => p + (c || 0), 0))) : of(0);
            }),
        );

        return {
            groupId: e.Id,
            currencyCode: e.CurrencyCode,
            costAmountVM$: combineLatest([costAmount$, amount$, amountWithTax$]).pipe(map(([costAmount, amount, costAmountGross]) => {
                if (!costAmount) {
                    return null;
                }
                return {
                    costAmount,
                    costAmountGross,
                    zs: costAmount ? (amount / costAmount) - 1 : null
                }
            })),
            amount$,
            amountWithTax$,
            amount: undefined,
            information$: combineLatest([
                getValueChangesObservableFromFormGroup(form, 'ItemNumber'),
                getValueChangesObservableFromFormGroup(form, 'Information'),
            ]).pipe(map(([position, information]) => position + ': ' + (information || ''))),
            isBookingPosition$: of(false),
        };
    };

    private getArlTableData = (e: AccountsReceivableLedgerEntity, arlDict?: Dictionary<AccountsReceivableLedgerEntity>): arlTableData<AccountsReceivableLedgerEntity> => {
        if (!this.arlFormDataService.getForm(e.Id)) {
            this.arlFormDataService.setFormByEntity(e, arlDict);
        }
        const form: arlTableDataArlForm = this.arlFormDataService.getForm(e.Id);
        if (form.controls.ARLIds.value.length === 0 && form.controls.childrenVisible.enabled) {
            form.controls.childrenVisible.disable();
            form.controls.childrenVisible.markAsPristine();
        }
        // const parentIds$ = this.arlFormDataService.parentIdsFromForms$(e.Id);
        // if (this._disabled) {
        // this.disableForm(form);
        // }
        // console.log('ARLIds', form.value.ARLIds);
        const calculatedAmount = new FormControl<number>(null);
        const baseCostSonstigesForm = new FormControl<number>(parseFloat(((e.BaseCost || 0) - (e.SalaryBaseCost || 0)).toFixed(4)), decimalPriceValidator());

        const globalPreCharge = this.aRLCalculationPreCharge;


        const orderDocumentType = this.liDocumentType === LedgerImportDocumentTypes.Order || this.liDocumentType === LedgerImportDocumentTypes.OrderConfirmation || this.liDocumentType === LedgerImportDocumentTypes.DeliveryNote || this.liDocumentType === LedgerImportDocumentTypes.ReturnDeliveryNote
        const surchargePercentFormValue = (!orderDocumentType || !this.allreadyCalculated) ? ArlTableService.getSurchargePercentFormValue(e, /*this.ARLCalculationPreChargeByTypes,*/ globalPreCharge, this.defaultSurcharges, this.qTypesDict) : 0;
        //
        // let diff = e.CostAmount ? 100 * ((e.BaseCost || 0) / e.CostAmount - 1) : 0;
        // if (typePreCharge?.percentage) {
        //     diff = diff - typePreCharge.percentage * 100;
        //     console.log(diff, typePreCharge.percentage);
        // }
        // if (globalPreCharge) {
        //     diff = diff - globalPreCharge * 100;
        //     console.log(diff, globalPreCharge);
        // }
        //
        // if (e.BaseCost) {
        //     surchargePercentFormValue = financialRound(diff);
        // } else if (!e.CostAmount) {
        //     const sz = surChargeForArlType(e.Type, this.defaultSurcharges);
        //     surchargePercentFormValue = surChargeForArlType(e.Type, this.defaultSurcharges)?.PercentageValue;
        // }
        const surchargePercentForm = new FormControl<number>(surchargePercentFormValue);

        // const amounts$ = merge(
        //     form.controls.InheritFromChildren.valueChanges,
        //     form.controls.Quantity.valueChanges,
        //     form.controls.BaseCost.valueChanges,
        //     form.controls.BaseCostGross.valueChanges,
        //     form.controls.Tax.valueChanges,
        // ).pipe(
        //     startWith(null),
        //     switchMap(() => getAmountFromForm$(form, this.arlFormDataService)), // immer aktuelle Form
        //     shareReplay({ bufferSize: 1, refCount: true }),
        // );
        const amounts$ = getAmountFromForm$(form, this.arlFormDataService).pipe(shareReplay({ bufferSize: 1, refCount: true }));

        const employeeCostSum$ = form.valueChanges.pipe(
            startWith(null),
            map(() =>
                form.controls.childArlsCalculation.value
                    ?.filter(c => c.Type === AccountsReceivableLedgerTypeEnum.EmployeeArl)
                    .reduce((sum, c) => sum + (c.CostAmount * c.Quantity), 0) ?? 0
            ),
                shareReplay({ bufferSize: 1, refCount: true })
        );

        const otherCostSum$ = form.valueChanges.pipe(
            startWith(null),
            map(() => {
                if (form.controls.InheritFromChildren.value) {
                  return form.controls.childArlsCalculation.value
                        ?.filter(c => c.Type !== AccountsReceivableLedgerTypeEnum.EmployeeArl)
                        .reduce((sum, c) => sum + (c.CostAmount * c.Quantity), 0) ?? 0
                }
                else{
                    return form.controls.CostAmount?.value ?? 0;
                }
            }),
            shareReplay({ bufferSize: 1, refCount: true })
        );

        const baseCostCostSum$ = combineLatest([employeeCostSum$, otherCostSum$]).pipe(
            map(([a, b]) => a + b),
            shareReplay({ bufferSize: 1, refCount: true })
        );

        const baseCostGrossCostSum$ = combineLatest([
            baseCostCostSum$,
            form.controls.Tax.valueChanges.pipe(startWith(null))
        ]).pipe(
            map(([baseCostCostSum, _]) => baseCostCostSum * (1 + (form.value.Tax ?? 0) / 100)),
            shareReplay({ bufferSize: 1, refCount: true })
        );






        const percentDiff$ = combineLatest([
            employeeCostSum$,
            otherCostSum$,
            amounts$,
            baseCostCostSum$,
        ]).pipe(
            map(([employee, other, amounts, baseCost]) => {
                const employeeBase = amounts?.salaryBaseCostWithArlAllowanceCharges ?? 0;
                const otherBase = amounts?.baseCostWithArlAllowanceCharges - employeeBase;
              //  const baseCostGrossBase = amounts?.baseCostGrossWithArlAllowanceCharges ?? 0;
                const baseCostBase = amounts?.baseCostWithArlAllowanceCharges ?? 0;


                return {
                    employee: employee != 0 ?((100 * employeeBase) / employee) - 100 :0 ,
                    other:   other != 0 ?  ((100 * otherBase) / other) - 100 : 0,
                    baseCost: baseCost != 0 ? ((100 * baseCostBase) / baseCost) - 100 : 0,
                  //  baseCostGross: ((100 * (baseCostGrossBase)) / baseCostGross) - 100
                };
            }),
            shareReplay({ bufferSize: 1, refCount: true })
        );

        // const position$ = this.positionStrings$.pipe(map((positions) => positions.get(e.Id)));
        const position$ = getValueChangesObservableFromFormGroup(form, 'ItemNumber');
        //ToDo normal BaseCost

        const rowdata = {
            // itemNumber: form.value.ItemNumber,
            // position: '',
            entity: e,
            isExpanded$: this.expandedElement$.pipe(map((exp) => exp === e.Id)),
            animationTrigger$: this.expandedElement$.pipe(map((exp) => (exp === e.Id ? 'expanded' : 'collapsed'))),
            calculatedAmount, /// deprecated, use basecost
            baseCostSonstigesForm,
            form,
            addQuantityHistoryForm: new FormControl<number>(null),
            surchargePercentForm,
            allowanceCount$: form.controls.BaseCostAllowances.valueChanges.pipe(
                startWith(null),
                map(() => form.controls.BaseCostAllowances.value.filter((v) => !v.arlType && v.percent < 0).length),
            ),
            chargeCount$: form.controls.BaseCostAllowances.valueChanges.pipe(
                startWith(null),
                map(() => form.controls.BaseCostAllowances.value.filter((v) => !v.arlType && v.percent > 0).length),
            ),
            chargeByTypeCount$: form.controls.BaseCostAllowances.valueChanges.pipe(
                startWith(null),
                map(() => form.controls.BaseCostAllowances.value.filter((v) => !!v.arlType && v.percent > 0).length),
            ),
            // position$,
            resource$: form.controls.ResourceId.valueChanges.pipe(
                startWith(null),
                switchMap(() => (form.controls.ResourceId.value ? this.store.select(getResourceById({ id: form.controls.ResourceId.value })) : of(null))),
            ),
            // baseCostWithArlAllowances$: combineLatest([form.controls.BaseCost.valueChanges.pipe(startWith(null)), form.controls.BaseCostAllowances.valueChanges.pipe(startWith(null))]).pipe(
            //     map(() => {
            //         const baseCost = form.controls.BaseCost.value || 0;
            //         const baseCostAllowances = form.controls.BaseCostAllowances.value.reduce((p, c) => p + c.percent, 0);
            //         return financialRound(baseCost * (1 + baseCostAllowances / 100));
            //     })
            // ),
            amount$: amounts$.pipe(
                map(({ amount }) => amount),
                // tap((a) => console.log('amount$', a, e)),
                shareReplay({ bufferSize: 1, refCount: true }),
            ),
            costAmount$: amounts$.pipe(
                map(({ costAmount }) => costAmount),
                // tap((a) => console.log('amount$', a, e)),
                shareReplay({ bufferSize: 1, refCount: true }),
            ),
            amountWithTax$: combineLatest([
                this.arlFormDataService.parentBaseCostAllowances$(form.value.Id),
                form.controls.InheritFromChildren.valueChanges.pipe(startWith(null)),
                form.controls.Quantity.valueChanges.pipe(startWith(null)),
                form.controls.BaseCost.valueChanges.pipe(startWith(null)),
                form.controls.BaseCostGross.valueChanges.pipe(startWith(null)),
                form.controls.Tax.valueChanges.pipe(startWith(null)),
                form.controls.FixedPrices.valueChanges.pipe(startWith(null)),
                form.controls.SurchargeOverride.valueChanges.pipe(startWith(null)),
                // calculatedAmount.valueChanges.pipe(startWith(null)),
            ]).pipe(
                map(([parentAllowances]) => {
                    return CalcAccountsReceivableLedgerBruttoAmountWithAllowances(
                        {
                            Quantity: form.controls.Quantity.getRawValue(),
                            Type: form.controls.Type.getRawValue(),
                            BaseCostGross: form.controls.BaseCostGross.getRawValue(),
                            BaseCostAllowances: form.controls.BaseCostAllowances.getRawValue(),
                            SurchargeOverride: form.controls.SurchargeOverride.getRawValue(),
                            FixedPrices: form.controls.FixedPrices.getRawValue(),
                        },
                        parentAllowances
                    );
                    //   return CalcAccountsReceivableLedgerAmount(form.controls.Quantity.value, form.controls.Tax.value, form.controls.BaseCost.value);
                }),
                // tap((a) => console.log('amountWithTax$', a, e)),
                shareReplay({ bufferSize: 1, refCount: true }),
            ),
            baseCostsWithAllowanceCharges$: amounts$.pipe(
                map((amounts) => {
                    return {
                        baseCostWithArlCharges: amounts.baseCostWithArlCharges,
                        baseCostWithArlAllowanceCharges: amounts.baseCostWithArlAllowanceCharges,
                        baseCostGrossWithArlAllowanceCharges: amounts.baseCostGrossWithArlAllowanceCharges,
                        salaryBaseCostWithArlCharges: amounts.salaryBaseCostWithArlCharges,
                        salaryBaseCostWithArlAllowanceCharges: amounts.salaryBaseCostWithArlAllowanceCharges,
                        otherBaseCostWithArlCharges: isNotNullOrUndefined(amounts.baseCostWithArlCharges) ? amounts.baseCostWithArlCharges - amounts.salaryBaseCostWithArlCharges : null,
                        otherBaseCostWithArlAllowanceCharges: isNotNullOrUndefined(amounts.baseCostWithArlAllowanceCharges) ? amounts.baseCostWithArlAllowanceCharges - amounts.salaryBaseCostWithArlAllowanceCharges : null,
                    };
                }),
            ),
            selectedQuantityTypeName$: this.store.select(getQuantityTypeDictionary).pipe(
                switchMap((qt) =>
                    form.controls.QuantityTypeId.valueChanges.pipe(
                        startWith(null),
                        map(() => {
                            const id = form.controls.QuantityTypeId.getRawValue();
                            return isNotNullOrUndefined(id) ? qt[id]?.Name || '' : '';
                        }),
                    ),
                ),
            ),
            employeeCostSum$,
            otherCostSum$,
            percentDiff$,
            baseCostCostSum$,
            baseCostGrossCostSum$,
            arlTableCalculationPositionHelper: null,
            isBookingPosition$: getValueChangesObservableFromFormGroup(form, 'Type').pipe(map((type) => isBookingPositionTypeEnum(type)), distinctUntilChanged(), shareReplay({refCount: true, bufferSize: 1})),
        };
        if (e.isBookingPosition) {
            if (!this.arlTablePositionHelperService.getArlCalculationHelper(e.Id)) {
                this.arlTablePositionHelperService.setArlCalculationHelper({
                        arlId: e.Id,
                        ledgerImportId: e.LedgerImportId,
                        multiplier: e.Multiplier,
                    },
                    position$,
                    this.aRLCalculationPreChargeByTypes$,
                    this.aRLCalculationPreCharge$,
                    this.arlSurchargeByTypes$,
                    (amount: { BaseCost: number; SalaryBaseCost: number }) => this.onAmountCalculated(rowdata, amount));
            }
            rowdata.arlTableCalculationPositionHelper = this.arlTablePositionHelperService.getArlCalculationHelper(e.Id);
        }

        // combineLatest({
        //     emp: rowdata.employeeCostSum$,
        //     amount: rowdata.amount$,
        //     amountWithTax: rowdata.amountWithTax$,
        //     baseCosts: rowdata.baseCostsWithAllowanceCharges$,
        //     resource: rowdata.resource$,
        //     position: rowdata.position$,
        //     percentDifs: rowdata.percentDiff$
        // }).subscribe(values => {
        //     console.log('TESTRowdata debug', {
        //         ...rowdata,
        //         form: rowdata.form.value,
        //         ...values
        //     });
        // });
        return rowdata;
    };
    private setArlIds = (array: (arlTableData<AccountsReceivableLedgerEntity> | groupEndPlaceholder)[]) => {
        console.log('setArlIds');
        this._arlIds = array
            .filter((v) => determineIfIsArlTableDataOrGroupEnd(v) && !v.form.value.ParentId)
            .filter(determineIfIsArlTableDataOrGroupEnd)
            .map((c) => c.entity.Id);
       this.ignoreLockOnce =  !this._itemNumbersLocked
        this.arlIdsChange.emit(this._arlIds.slice());

        console.log('setArlIds', this._arlIds.slice());
    };
    private updateChildArlFormsFromArlIds = (array: (arlTableData<AccountsReceivableLedgerEntity> | groupEndPlaceholder)[]) => {
        array.forEach((d) => {
            if (determineIfIsArlTableDataOrGroupEnd(d)) {
                if (d.entity.Type === AccountsReceivableLedgerTypeEnum.Group) {
                    if (d.form.value.ARLIds.length !== d.form.controls.childArls.length || d.form.value.ARLIds.some((id, index) => this.arlFormDataService.getForm(id) !== d.form.controls.childArls.at(index))) {
                        d.form.controls.childArls.clear();
                        d.form.value.ARLIds.forEach((id) => d.form.controls.childArls.push(this.arlFormDataService.getForm(id)));
                    }
                }
            }
        });
    };
    private updateParentIds = (array: (arlTableData<AccountsReceivableLedgerEntity> | groupEndPlaceholder)[]) => {
        let currentParent: number[] = [];
        let indexFromParent: number[] = [];
        array.forEach((d) => {
            if (determineIfIsArlTableDataOrGroupEnd(d)) {
                if (d.form.value.ParentId !== (currentParent.length ? currentParent[currentParent.length - 1] : null)) {
                    d.form.controls.ParentId.setValue(currentParent.length ? currentParent[currentParent.length - 1] : null);
                    d.form.controls.ParentId.markAsDirty();
                    if (d.form.value?.ParentId) {
                        const parentForm = this.arlFormDataService.getForm(d.form.value.ParentId);
                        if (parentForm.value.IsOptional) {
                            d.form.controls.IsOptional.setValue(true);
                            d.form.controls.IsOptional.markAsDirty();
                        }
                        // todo muss das mit crossed out nicht auch passieren ?
                    }
                }
                const parent: arlTableData = d.form.value.ParentId && (array.find((a) => determineIfIsArlTableDataOrGroupEnd(a) && d.form.value.ParentId === a.entity.Id) as arlTableData);
                console.log('parent', parent);
                if (parent && indexFromParent.length && indexFromParent[indexFromParent.length - 1] !== parent.form.value.ARLIds.indexOf(d.entity.Id)) {
                    const missing = (parent.form.value.ARLIds.length - 1 - indexFromParent[indexFromParent.length - 1]) * -1;
                    const old = parent.form.value.ARLIds.slice();
                    console.log(old, missing, parent.form.value.ARLIds.length, indexFromParent[indexFromParent.length - 1]);
                    if (missing > 0) {
                        for (let k = missing; k > 0; k--) {
                            old.push(null);
                        }
                    }
                    parent.form.controls.ARLIds.setValue(old.map((id, i) => (i === indexFromParent[indexFromParent.length - 1] ? d.entity.Id : id)));
                    parent.form.controls.ARLIds.markAsDirty();
                    console.log('parent.arlIds', parent.form.controls.ARLIds.value);
                }
                if (indexFromParent.length) {
                    indexFromParent[indexFromParent.length - 1]++;
                }
                if (d.entity.Type === AccountsReceivableLedgerTypeEnum.Group) {
                    currentParent.push(d.entity.Id);
                    indexFromParent.push(0);
                }
            } else {
                const groupStart: arlTableData = array.find((e) => determineIfIsArlTableDataOrGroupEnd(e) && e.entity.Id === d.groupId) as arlTableData;

                const toMuchChilds = (indexFromParent[indexFromParent.length - 1] - groupStart.form.value.ARLIds.length) * -1;
                console.log(toMuchChilds);
                if (toMuchChilds > 0) {
                    groupStart.form.controls.ARLIds.setValue(groupStart.form.value.ARLIds.slice(0, indexFromParent[indexFromParent.length - 1]));
                    groupStart.form.controls.ARLIds.markAsDirty();
                }
                currentParent.pop();
                indexFromParent.pop();
            }
        });
        console.log('update parents');
        console.log(array.filter(determineIfIsArlTableDataOrGroupEnd).map((a) => JSON.parse(JSON.stringify(a.form.value))));
        this.updateChildArlFormsFromArlIds(array);
    };

    async removeArlsFromTable(ids: number[]) {
        let array = await firstValueFrom(this.tableData2$);
        const indexes: number[] = [];
        array.forEach((e, i) => {
            if (determineIfIsArlTableDataOrGroupEnd(e)) {
                if (ids.includes(e.entity.Id)) {
                    indexes.push(i);
                }
            } else if (ids.includes(e.groupId)) {
                indexes.push(i);
            }
        });
        indexes.forEach((index, i) => array.splice(index - i, 1));
        this.updateParentIds(array);
        this.setArlIds(array);
    }

    /**
     *
     * @param array
     * @param arl
     * @param index
     * @param arlDict only needed for init Formcontrol if there is a Group with children
     * @private
     */
    private addArlToArray(array: (arlTableData<AccountsReceivableLedgerEntity> | groupEndPlaceholder)[], arl: AccountsReceivableLedgerEntity, index?: number, arlDict?: Dictionary<AccountsReceivableLedgerEntity>) {
        array.push(this.getArlTableData(arl, arlDict));
        if (isNotNullOrUndefined(index)) {
            moveItemInArray(array, array.length - 1, index);
        }
        this.updateParentIds(array);
        this.setArlIds(array);
    }
    /*
    public addArlsToTable(arls: AccountsReceivableLedgerEntity[]) {
        return firstValueFrom(combineLatest([this.tableData2$, this.store.select(getAccountsReceivableLedgerDictionary)])).then(([array, arlDict]) => {
            arls.forEach((arl) => {
                this.addArlToArray(array, arl, null, arlDict);
            });
        });
    }
     */
    public addArlsToTable(arls: AccountsReceivableLedgerEntity[], index) {
        return firstValueFrom(combineLatest([this.tableData2$, this.arlDataService.selectAllArlsDict(), this.store.select(getQuantityTypes)])).then(([array, allArls, quantityTypes]) => {
            const minuteType = quantityTypes.find((qt) => qt.Name === QuantityTypeNames.Minutes);
            const hourType = quantityTypes.find((qt) => qt.Name === QuantityTypeNames.Hours || qt.Name === QuantityTypeNames.Hours2 || qt.Name === QuantityTypeNames.Hours3 || qt.Name === QuantityTypeNames.Hours4);

            const getArlChildrenTableData: (id: number) => (arlTableData<AccountsReceivableLedgerEntity> | groupEndPlaceholder)[] = (id: number) => {
                const arl = allArls[id];
                if (!arl) {
                    console.error('arl not found, id; ' + id);
                    return [];
                }
                let form = this.arlFormDataService.getForm(id);
                if (!form) {
                    this.arlFormDataService.setFormByEntity(arl, allArls);
                }
                form = this.arlFormDataService.getForm(id);
                if (this.forceQuantityTypeIdForEmployeeArls) {
                    if (form.value.Type === AccountsReceivableLedgerTypeEnum.EmployeeArl) {
                        switchHourMinute(this.forceQuantityTypeIdForEmployeeArls, form, minuteType.Id, hourType.Id);
                    }
                    if (form.value.childArlsCalculation?.length) {
                        form.controls.childArlsCalculation.controls.forEach((form) => {
                            if (form.value.Type === AccountsReceivableLedgerTypeEnum.EmployeeArl) {
                                switchHourMinuteCalc(this.forceQuantityTypeIdForEmployeeArls, form, minuteType.Id, hourType.Id);
                            }
                        });
                    }
                }

                const childArlIds = form?.value.ARLIds || uniqArray(arl.ArlIds);
                if (arl.Type === AccountsReceivableLedgerTypeEnum.Group) {
                    const ret = [this.getArlTableData(arl, allArls), ...childArlIds.map((i) => getArlChildrenTableData(i)).flat(), this.getGroupEnd(arl)];
                    console.log('ret', ret, childArlIds);
                    return ret;
                }
                return [this.getArlTableData(arl, allArls)];
            };
            arls.filter((a) => !a.ParentId).forEach((arl) =>
                getArlChildrenTableData(arl.Id).forEach((a) => {
                    array.push(a);
                    if (isNotNullOrUndefined(index)) {
                        moveItemInArray(array, array.length - 1, index);
                    }
                    index++;
                }),
            );
            this.updateParentIds(array);
            this.setArlIds(array);
        });
    }

    public parseItemNumberSegments(itemNumber: string | null | undefined): number[] | null {
        if (itemNumber === null || itemNumber === undefined || itemNumber.trim() === '') {
            return null; // leere ItemNumber -> sortiert ganz nach unten
        }
        const ret = itemNumber
            .split('.')
            .filter((segment) => segment !== '')
            .map((segment) => {
                const digitsOnly = segment.replace(/[^0-9]/g, ''); // Buchstaben ignorieren
                const parsed = parseInt(digitsOnly, 10);
                return Number.isNaN(parsed) ? 0 : parsed;
            });
        return ret;
    }

    public compareItemNumberSegments(a: number[] | null, b: number[] | null): number {
        if (a === null && b === null) return 0;
        if (a === null) return 1;  // null sortiert nach unten
        if (b === null) return -1;

        const len = Math.max(a.length, b.length);
        for (let i = 0; i < len; i++) {
            const diff = (a[i] ?? 0) - (b[i] ?? 0);
            if (diff !== 0) {
                return diff;
            }
        }
        return 0;
    }


    public findInsertionIndex(
        array: (arlTableData<AccountsReceivableLedgerEntity> | groupEndPlaceholder)[],
        newSegments: number[] | null,
    ): number {
      if (newSegments === null) {
            return array.length;
        }

        const getSegments = (entry: arlTableData<AccountsReceivableLedgerEntity>): number[] | null =>
            this.parseItemNumberSegments(/*entry.itemNumber ?? */entry.form.controls.ItemNumber.value);

        const isGroupStart = (entry: arlTableData<AccountsReceivableLedgerEntity>): boolean =>
            entry.entity.Type === AccountsReceivableLedgerTypeEnum.Group;

        const findMatchingGroupEnd = (groupStartIndex: number): number => {
            let depth = 1;
            let j = groupStartIndex + 1;
            while (j < array.length) {
                const e = array[j];
                if (!determineIfIsArlTableDataOrGroupEnd(e)) {
                    depth--;
                    if (depth === 0) {
                        return j;
                    }
                } else if (isGroupStart(e)) {
                    depth++;
                }
                j++;
            }
            return array.length;
        };


        const findInRange = (start: number, end: number): number => {
            let i = start;
            while (i < end) {
                const entry = array[i];
                if (!determineIfIsArlTableDataOrGroupEnd(entry)) {
                    return i;
                }
                const entrySegments = getSegments(entry);
                if (entrySegments === null) {
                    i++;
                    continue;
                }

                const isAncestorGroup =
                    isGroupStart(entry) &&
                    newSegments.length > entrySegments.length &&
                    entrySegments.every((segment, idx) => segment === newSegments[idx]);

                if (isAncestorGroup) {
                    const childStart = i + 1;
                    const childEnd = findMatchingGroupEnd(i);
                    return findInRange(childStart, childEnd);
                }

                const comparison = this.compareItemNumberSegments(entrySegments, newSegments);
                if (comparison > 0) {
                    return i;
                }
                i = isGroupStart(entry) ? findMatchingGroupEnd(i) + 1 : i + 1;
            }
            return end;
        };

        return findInRange(0, array.length);
    }







    onClick(typestr: addArlDragButtonType) {
        const offset = 0; // drag button
        this.isInvalidDragEvent = true;
        firstValueFrom(this.tableData2$).then((array) => {
            this.dialog
                .open<ArlPositionDialogComponent, ArlPositionDialogComponentDialogData, ArlPositionDialogComponentDialogReturnData>(ArlPositionDialogComponent, {
                    width: '40vw',
                    data: {
                        Array: array,
                        AllowOnlyLastPositionInGroup: this._itemNumbersLocked,
                    },
                })
                .afterClosed()
                .pipe()
                .subscribe((index: number) => {
                    if (index != null) {
                        this.AddARLDefaultValues.itemNumber = AccountsReceivableLedgerEntity.autogenerateItemNumber;

                        if (typestr === 'arl' || typestr === 'fremdleistung-arl' || typestr === 'salary-arl' || typestr === 'other-arl') {
                            this.ls.startLoading('arl-table-component-create-arls');
                            const type =
                                typestr === 'arl'
                                    ? AccountsReceivableLedgerTypeEnum.Arl
                                    : typestr === 'fremdleistung-arl'
                                    ? AccountsReceivableLedgerTypeEnum.ExternalService
                                    : typestr === 'other-arl'
                                    ? AccountsReceivableLedgerTypeEnum.Other
                                    : AccountsReceivableLedgerTypeEnum.EmployeeArl;
                            this.arlDataService
                                .addArls([{ ...this.AddARLDefaultValues, information: 'Neue Leistung', type }])
                                .then((arls) => {
                                    this.addArlToArray(array, arls[0], index);
                                })
                                .finally(() => this.ls.endLoading('arl-table-component-create-arls'));
                        } else if (typestr === 'resource-arl') {
                            this.ls.startLoading('arl-table-component-create-resource-arl');
                            this.arlDataService
                                .addArls([
                                    {
                                        ...this.AddARLDefaultValues,
                                        information: 'Neues ' + ResourceEntity.EntityName,
                                        type: AccountsReceivableLedgerTypeEnum.ResourceArl,
                                    },
                                ])
                                .then((arls) => {
                                    this.addArlToArray(array, arls[0], index);
                                })
                                .finally(() => this.ls.endLoading('arl-table-component-create-resource-arl'));
                        } else if (typestr === 'material-arl') {
                            this.ls.startLoading('arl-table-component-create-material-arl');
                            this.arlDataService
                                .addArls([
                                    {
                                        ...this.AddARLDefaultValues,
                                        information: 'Neues ' + MaterialEntity.EntityName,
                                        type: AccountsReceivableLedgerTypeEnum.MaterialArl,
                                    },
                                ])
                                .then((arls) => {
                                    this.addArlToArray(array, arls[0], index);
                                })
                                .finally(() => this.ls.endLoading('arl-table-component-create-material-arl'));
                        } else if (typestr === 'group') {
                            this.AddARLDefaultValues.hideInGroupSummary = false;
                            this.ls.startLoading('arl-table-component-create-group-arls');
                            this.arlDataService
                                .addArls([
                                    {
                                        ...this.AddARLDefaultValues,
                                        information: 'Neuer Titel',
                                        type: AccountsReceivableLedgerTypeEnum.Group,
                                    },
                                ])
                                .then((arls) => {
                                    array.push(this.getArlTableData(arls[0]));
                                    array.push(this.getGroupEnd(arls[0]));
                                    moveItemInArray(array, array.length - 2, index);
                                    moveItemInArray(array, array.length - 1, index + 1);
                                    this.updateParentIds(array);
                                    this.setArlIds(array);
                                    // this.arlIdsChange.emit(array.filter(determineIfIsArlTableDataOrGroupEnd).map((c) => c.entity.Id));
                                })
                                .finally(() => this.ls.endLoading('arl-table-component-create-group-arls'));
                        } else if (typestr === 'text') {
                            this.AddARLDefaultValues.hideInGroupSummary = true;
                            this.ls.startLoading('arl-table-component-create-text-arls');
                            this.arlDataService
                                .addArls([
                                    {
                                        ...this.AddARLDefaultValues,
                                        information: 'Neuer Text',
                                        type: AccountsReceivableLedgerTypeEnum.Text,
                                    },
                                ])
                                .then((arls) => {
                                    array.push(this.getArlTableData(arls[0]));
                                    moveItemInArray(array, array.length - 1, index);
                                    this.updateParentIds(array);
                                    this.setArlIds(array);
                                    // this.arlIdsChange.emit(array.filter(determineIfIsArlTableDataOrGroupEnd).map((c) => c.entity.Id));
                                })
                                .finally(() => this.ls.endLoading('arl-table-component-create-text-arls'));
                        }
                    }
                });
        });
    }

    waitForTimeout(ms: number): Promise<void> {
        return new Promise((resolve) => setTimeout(resolve, ms));
    }

    private async moveItemInArlArray(fromIndex: number, toIndex: number, elementToMove: arlTableData<AccountsReceivableLedgerEntity> | groupEndPlaceholder) {
        // console.log('moveItemInArlArray', fromIndex, toIndex, elementToMove);
        if (toIndex === fromIndex || this._itemNumbersLocked) {
            return;
        }

        const array = await firstValueFrom(this.tableData2$);
        // elementToMove : TableData<T, K>
        // console.log(eelementToMove);
        // check is group

        let completeGroupMustBeMoved = false;
        // let groupArlCount: number;
        let groupStartIndex: number;
        let groupEndIndex: number;
        if (!determineIfIsArlTableDataOrGroupEnd(elementToMove) || (elementToMove as arlTableData).entity?.Type === AccountsReceivableLedgerTypeEnum.Group) {
            // check is group start before end
            let otherIndex = array.findIndex(
                (v) =>
                    (determineIfIsArlTableDataOrGroupEnd(v) && !determineIfIsArlTableDataOrGroupEnd(elementToMove) && (elementToMove as groupEndPlaceholder).groupId === v.entity?.Id) ||
                    (!determineIfIsArlTableDataOrGroupEnd(v) && determineIfIsArlTableDataOrGroupEnd(elementToMove) && v.groupId === elementToMove.entity?.Id),
            );
            const goesDown = toIndex > fromIndex;
            // console.log(otherIndex, currentIndex, determineIfIsArlTableDataOrGroupEnd(elementToMove));

            if (!determineIfIsArlTableDataOrGroupEnd(elementToMove) && !goesDown && otherIndex >= toIndex) {
                return;
            } else if (determineIfIsArlTableDataOrGroupEnd(elementToMove) && goesDown && otherIndex <= toIndex) {
                return;
                // complete group must be moved
                // ganze Gruppe verschieben ist erstmal nicht gewollt, kommt ggf via mehrfachauswahl, deshalb bleibt es hier noch stehen
                completeGroupMustBeMoved = true;
                groupStartIndex = fromIndex;
                groupEndIndex = otherIndex;
            }

            if (!completeGroupMustBeMoved) {
                //count groups between
                const testArray = array.slice();
                moveItemInArray(testArray, fromIndex, toIndex);
                const otherIndexAfterMove = testArray.findIndex(
                    (v) =>
                        (determineIfIsArlTableDataOrGroupEnd(v) && !determineIfIsArlTableDataOrGroupEnd(elementToMove) && (elementToMove as groupEndPlaceholder).groupId === v.entity?.Id) ||
                        (!determineIfIsArlTableDataOrGroupEnd(v) && determineIfIsArlTableDataOrGroupEnd(elementToMove) && v.groupId === elementToMove.entity?.Id),
                );

                const startIndex = otherIndexAfterMove < toIndex ? otherIndexAfterMove : toIndex;
                const endIndex = otherIndexAfterMove > toIndex ? otherIndexAfterMove : toIndex;
                const subArr = testArray.slice(startIndex + 1, endIndex);
                const groupCount = subArr.filter((v, index) => determineIfIsArlTableDataOrGroupEnd(v) && v.entity.Type === AccountsReceivableLedgerTypeEnum.Group).length;
                const groupEndCount = subArr.filter((v, index) => !determineIfIsArlTableDataOrGroupEnd(v)).length;

                if (groupCount !== groupEndCount) {
                    return;
                }
            }
            // console.log(testArray);
            // console.log(JSON.stringify(testArray.map((a) => ({ type: determineIfIsArlTableDataOrGroupEnd(a) ? 'arl' : 'group-end', id: determineIfIsArlTableDataOrGroupEnd(a) ? a.entity.Id : a.groupId }))));


        }
        if (completeGroupMustBeMoved) {
            const groupArlCount = groupEndIndex - groupStartIndex + 1;
            for (let i = 0; i < groupArlCount; i++) {
                moveItemInArray(array, groupStartIndex, toIndex + (groupArlCount -1));
            }
        } else {
            moveItemInArray(array, fromIndex, toIndex);
        }
        this.updateParentIds(array);

        //this.updateParentIds(/*startIndex, endIndex,*/ array);
        this.setArlIds(array);
    }
    async OnListDrop(event?: CdkDragDrop<arlTableData | groupEndPlaceholder | addArlDragButtonType, any, addArlDragButtonType | arlTableData | groupEndPlaceholder>) {
        const pagingOffset = this.paginator.pageIndex * this.paginator.pageSize;
        const currentIndex = pagingOffset + event.currentIndex - 1;
        const previousIndex = pagingOffset + event.previousIndex - 1;

        this.isInvalidDragEvent = true;
        if (event.previousContainer === event.container) {
            // bestehende Position verschieben
            await this.moveItemInArlArray(previousIndex, currentIndex, event.item.data as groupEndPlaceholder | arlTableData<AccountsReceivableLedgerEntity>);
        } else {
            // neue Position erstellen
            const array = await firstValueFrom(this.tableData2$);
            this.AddARLDefaultValues.itemNumber = AccountsReceivableLedgerEntity.autogenerateItemNumber;
            const setSurchargeOverride = async (arlTableData: arlTableData<AccountsReceivableLedgerEntity>)=> {
                if (arlTableData.form.controls.ParentId.getRawValue()) {
                    const ParentBaseCostAllowances = await firstValueFrom(this.arlFormDataService.parentBaseCostAllowances$(arlTableData.form.controls.Id.getRawValue()));
                    const surchargeOverride = ParentBaseCostAllowances.flat().find(ac => ac.arlType === arlTableData.form.controls.Type.getRawValue() && ac.type === 'surchargeOverride')?.percent;
                    if (isNotNullOrUndefined(surchargeOverride)) {
                        arlTableData.form.controls.SurchargeOverride.markAsDirty();
                        arlTableData.form.controls.SurchargeOverride.setValue(surchargeOverride);
                    }
                }
            }
            if (event.item.data === 'arl' || event.item.data === 'fremdleistung-arl' || event.item.data === 'salary-arl' || event.item.data === 'other-arl') {
                this.ls.startLoading('arl-table-component-create-arls');
                const type =
                    event.item.data === 'arl'
                        ? AccountsReceivableLedgerTypeEnum.Arl
                        : event.item.data === 'fremdleistung-arl'
                            ? AccountsReceivableLedgerTypeEnum.ExternalService
                            : event.item.data === 'other-arl'
                                ? AccountsReceivableLedgerTypeEnum.Other
                                : AccountsReceivableLedgerTypeEnum.EmployeeArl;
                const information = event.item.data === 'arl' ? 'Neue Leistung' : event.item.data === 'fremdleistung-arl' ? 'Neue Fremdleistung' : event.item.data === 'other-arl' ? 'Neue sonstige Leistung' : 'Neuer Lohn';
                let quantityTypeId = this.AddARLDefaultValues?.quantityTypeId;
                if (event.item.data === 'salary-arl' && this.forceQuantityTypeIdForEmployeeArls) {
                    quantityTypeId = this.forceQuantityTypeIdForEmployeeArls;
                }
                this.arlDataService
                    .addArls([{ ...this.AddARLDefaultValues, quantityTypeId, information, type }])
                    .then((arls) => {
                        this.addArlToArray(array, arls[0], currentIndex);
                        setSurchargeOverride(array[currentIndex] as arlTableData<AccountsReceivableLedgerEntity>);
                    })
                    .finally(() => this.ls.endLoading('arl-table-component-create-arls'));
            } else if (event.item.data === 'resource-arl') {
                this.ls.startLoading('arl-table-component-create-resource-arl');
                this.arlDataService
                    .addArls([{ ...this.AddARLDefaultValues, information: 'Neues ' + ResourceEntity.EntityName, type: AccountsReceivableLedgerTypeEnum.ResourceArl }])
                    .then((arls) => {
                        this.addArlToArray(array, arls[0], currentIndex);
                        setSurchargeOverride(array[currentIndex] as arlTableData<AccountsReceivableLedgerEntity>);
                    })
                    .finally(() => this.ls.endLoading('arl-table-component-create-resource-arl'));
            } else if (event.item.data === 'material-arl') {
                this.ls.startLoading('arl-table-component-create-material-arl');
                this.arlDataService
                    .addArls([{ ...this.AddARLDefaultValues, information: 'Neues ' + MaterialEntity.EntityName, type: AccountsReceivableLedgerTypeEnum.MaterialArl }])
                    .then((arls) => {
                        this.addArlToArray(array, arls[0], currentIndex);
                        setSurchargeOverride(array[currentIndex] as arlTableData<AccountsReceivableLedgerEntity>);
                    })
                    .finally(() => this.ls.endLoading('arl-table-component-create-material-arl'));
            } else if (event.item.data === 'group') {
                this.AddARLDefaultValues.hideInGroupSummary = false;
                this.ls.startLoading('arl-table-component-create-group-arls');
                this.arlDataService
                    .addArls([{ ...this.AddARLDefaultValues, information: 'Neuer Titel', type: AccountsReceivableLedgerTypeEnum.Group }])
                    .then((arls) => {
                        array.push(this.getArlTableData(arls[0]));
                        array.push(this.getGroupEnd(arls[0]));
                        moveItemInArray(array, array.length - 2, currentIndex);
                        moveItemInArray(array, array.length - 1, currentIndex + 1);
                        this.updateParentIds(array);
                        this.setArlIds(array);
                        // this.arlIdsChange.emit(array.filter(determineIfIsArlTableDataOrGroupEnd).map((c) => c.entity.Id));
                        setSurchargeOverride(array[currentIndex] as arlTableData<AccountsReceivableLedgerEntity>);
                    })
                    .finally(() => this.ls.endLoading('arl-table-component-create-group-arls'));
            } else if (event.item.data === 'text') {
                this.AddARLDefaultValues.hideInGroupSummary = true;
                this.ls.startLoading('arl-table-component-create-text-arls');
                this.arlDataService
                    .addArls([{ ...this.AddARLDefaultValues, information: 'Neuer Text', type: AccountsReceivableLedgerTypeEnum.Text }])
                    .then((arls) => {
                        array.push(this.getArlTableData(arls[0]));
                        moveItemInArray(array, array.length - 1, currentIndex);
                        this.updateParentIds(array);
                        this.setArlIds(array);
                        // this.arlIdsChange.emit(array.filter(determineIfIsArlTableDataOrGroupEnd).map((c) => c.entity.Id));
                        setSurchargeOverride(array[currentIndex] as arlTableData<AccountsReceivableLedgerEntity>);
                    })
                    .finally(() => this.ls.endLoading('arl-table-component-create-text-arls'));
            }

            // recalculate positions
            // recalculate groupEndSums

            // console.log({ array });
            // console.log({ newOrder: array.filter(determineIfIsArlTableDataOrGroupEnd).map(c => c.entity.Id) });
            // // this.tableData2$.next(array);
            // // this.arlsChange.emit(this.tableData$.value.map((a) => (determineIfIsArlTableDataOrGroupTableData(a) ? a.entity : a.group)));
            // this.arlIdsChange.emit(array.filter(determineIfIsArlTableDataOrGroupEnd).map(c => c.entity.Id));
            // console.groupEnd();
        }
    }

    getQuantity = ({ entity, form }: arlTableData<any>): string => {
        const quantityFormValue = form.controls.Quantity.getRawValue();
        return isBookingPositionTypeEnum(form.controls.Type.getRawValue()) && isNotNullOrUndefined(quantityFormValue) ? formatNumber(quantityFormValue, this.locale) : '';
    };
    // getQuantityType$ = this.store.select(getQuantityTypeDictionary).pipe(
    //     map(
    //         (qt) =>
    //             ({ entity, form }: arlTableData<any>) =>
    //                 isNotNullOrUndefined(form.controls.QuantityTypeId.getRawValue()) ? qt[form.controls.QuantityTypeId.getRawValue()]?.Name || '' : '',
    //     ),
    // );

    getBaseCost = ({ entity, form }: arlTableData<any>): string => {
        const baseCostFormValue  = form.controls.BaseCost.getRawValue()
        return isBookingPositionTypeEnum(form.controls.Type.getRawValue()) && isNotNullOrUndefined(baseCostFormValue)
            ? formatCurrency(baseCostFormValue, this.locale, getCurrencySymbol(entity.CurrencyCode, 'narrow', this.locale), entity.CurrencyCode)
            : '';
    };
    getBaseCostGross = ({ entity, form }: arlTableData<any>): string => {
        const baseCostGrossFormValue = form.controls.BaseCostGross.getRawValue();
        return isBookingPositionTypeEnum(form.controls.Type.getRawValue()) && isNotNullOrUndefined(baseCostGrossFormValue)
            ? formatCurrency(baseCostGrossFormValue, this.locale, getCurrencySymbol(entity.CurrencyCode, 'narrow', this.locale), entity.CurrencyCode)
            : '';
    };
    dataAccessor(data: arlTableData<AccountsReceivableLedgerEntity> | groupEndPlaceholder, name: 'Quantity' | 'BaseCost' | 'BookingText' | 'BaseCostGross') {
        if (determineIfIsArlTableDataOrGroupEnd(data)) {
            switch (name) {
                case 'Quantity':
                    return this.getQuantity(data);
                case 'BaseCost':
                    return this.getBaseCost(data);
                case 'BaseCostGross':
                    return this.getBaseCostGross(data);
                case 'BookingText':
                    return data.form.controls.BookingText.getRawValue();
            }
        }
        return '';
    }
    // todo auch in sevice auslagern
    async SubmitCalculationArls(): Promise<void> {
        const rows = await firstValueFrom(this.tableData2$);
        const filteredRows = rows.filter(determineIfIsArlTableDataOrGroupEnd).filter(r => r.arlTableCalculationPositionHelper);
        if (filteredRows.length) {
            await Promise.all(filteredRows.map(d => d.arlTableCalculationPositionHelper.submit()));
        }

        // console.log(this.detailRows, this.detailRows.length);
        //
        // return firstValueFrom(this.detailRows.length ? combineLatest(this.detailRows.map((detailRow) => detailRow.Submit())) : of([] as Array<void>));

        // return firstValueFrom(this.detailRows.length ? combineLatest(this.detailRows.map((detailRow) => detailRow.Submit())) : of([])).then(() => {
        // return firstValueFrom(combineLatest([this.tableData$, this.store.select(getAccountsReceivableLedgerDictionary)])).then(([tableData, arlsFromState]) => {
        //     if (tableData.length === 0) {
        //         return { someWasChanged: false, arls: [] };
        //     }
        //     const toChange: DaveMutationChangeAccountsReceivableLedgerArgs[] = [];
        //     const toReturn: AccountsReceivableLedgerEntity[] = [];
        //     tableData.forEach((td) => {
        //         if (determineIfIsArlTableDataOrGroupEnd(td)) {
        //             // fix dafür das es arls gibt bei denen die Parentid nicht null gesetzt wurde, da ein bug im Frontend war.
        //             // todo das kann raus wenn man das in der Datenbank repariert hat D277-5096
        //             const wrongParentId = td.form.controls.ParentId.getRawValue() && rootARLIds?.includes(td.entity.Id)
        //             if (td.form.dirty || wrongParentId) {
        //                 if (wrongParentId) {
        //                     console.error('arl wrong parent id', td.entity.Id, td.form.controls.ParentId.getRawValue(), rootARLIds);
        //                     td.form.controls.ParentId.setValue(null);
        //                 }
        //                 console.log(td.entity.Id, JSON.stringify(td.form.value));
        //                 toChange.push(this.getChangeMutationPayload(td));
        //             } else {
        //                 if (!arlsFromState[td.entity.Id]) {
        //                     console.error('arlNotFound', td.entity.Id);
        //                 }
        //                 toReturn.push(arlsFromState[td.entity.Id]);
        //             }
        //         }
        //     });
        //     const markAllPristine = () => {
        //         tableData.forEach((td) => {
        //             if (determineIfIsArlTableDataOrGroupEnd(td)) {
        //                 if (td.form.dirty) {
        //                     td.form.markAsPristine(); // (dirty) fix bug, beim speichern klicken werden die groups dirty, die controls darin aber nicht
        //                 }
        //             }
        //         });
        //     };
        //     return toChange.length
        //         ? this.arlDataService.changeArls(toChange).then((changed) => {
        //               markAllPristine();
        //               return { someWasChanged: true, arls: [...changed, ...toReturn] };
        //           })
        //         : { someWasChanged: false, arls: toReturn };
        // });
        // });
    }

    // isExpanded(element: TableData<T>) {
    //     return this.expandedElement === element;
    // }
    expandRow(element: null | arlTableData<AccountsReceivableLedgerEntity> | groupEndPlaceholder) {
        if (!element) {
            this.expandedElement$.next(null);
        } else if (determineIfIsArlTableDataOrGroupEnd(element)) {
            if (this.expandedElement$.value !== element.entity?.Id) {
                this.expandedElement$.next(element.entity.Id);
            }
        }
    }
    onAmountCalculated(element: arlTableData<any>, amount: { BaseCost: number; SalaryBaseCost: number }) {
        element.calculatedAmount.setValue(amount.BaseCost);
        if (element.form.controls.InheritFromChildren.value) {
            if (amount.BaseCost !== element.form.controls.BaseCost.getRawValue()) {
                element.form.controls.BaseCost.setValue(amount.BaseCost);
                element.form.controls.BaseCost.markAsDirty();
                this.baseCostChange(element);
            }
            if (amount.SalaryBaseCost !== element.form.controls.SalaryBaseCost.getRawValue()) {
                element.form.controls.SalaryBaseCost.setValue(amount.SalaryBaseCost);
                element.form.controls.SalaryBaseCost.markAsDirty();
            }
            const sonst = parseFloat((amount.BaseCost - amount.SalaryBaseCost).toFixed(2));
            if (element.form.controls.sonstigesBaseCost.getRawValue() !== sonst) {
                element.form.controls.sonstigesBaseCost.setValue(sonst);
                element.form.controls.sonstigesBaseCost.markAsDirty();
            }
        }
    }
    onAbortClick(element: arlTableData<any>) {
        element.arlTableCalculationPositionHelper?.reset();
        element.form.reset();
        this.expandRow(null);
    }
    onDeleteClick(element: arlTableData<AccountsReceivableLedgerEntity>) {
        if (element.entity) {
            this.DeleteClick.emit([element.entity.Id]);
            this.expandedElement$.next(null);
        }
    }
    onToggleFixedPrice(element: arlTableData<any>) {
        if (!isBookingPositionTypeEnum(element.form.controls.Type.getRawValue())) {
            return;
        }

        if (element.form.controls.FixedPrices.getRawValue()) {
            element.form.controls.FixedPrices.markAsDirty();
            element.form.controls.FixedPrices.setValue(false);
            this.recalculateSurcharge(element);
        } else {
            const parentAllowances = this.arlFormDataService.parentForms(element.form.controls.Id.getRawValue()).map((form) => form.controls.BaseCostAllowances.getRawValue());
            const arlValues = {
                Type: element.form.controls.Type.getRawValue(),
                BaseCost: element.form.controls.BaseCost.getRawValue(),
                BaseCostGross: element.form.controls.BaseCostGross.getRawValue(),
                BaseCostAllowances: element.form.controls.BaseCostAllowances.getRawValue(),
                SurchargeOverride: element.form.controls.SurchargeOverride.getRawValue(),
                FixedPrices: element.form.controls.FixedPrices.getRawValue(),
                SalaryBaseCost: element.form.controls.SalaryBaseCost.getRawValue(),
                ParentId: element.form.controls.ParentId.getRawValue(),
                InheritFromChildren: element.form.controls.InheritFromChildren.getRawValue(),
                CostAmount: element.form.controls.CostAmount.getRawValue(),
                // CostAmountAllowance: element.form.controls.CostAmountAllowance.getRawValue(),
            }
            const preis = CalcAccountsReceivableLedgerNettoBaseCostWithAllowancesCharges(arlValues, parentAllowances);
            const preisGross = CalcAccountsReceivableLedgerBruttoBaseCostWithAllowancesCharges(arlValues, parentAllowances);

            const baseCostSalaryRatio = arlValues.BaseCost ? arlValues.SalaryBaseCost / arlValues.BaseCost : 0;
            const preisSalaryPart = financialRound(preis * baseCostSalaryRatio);


            // const parentOverride = () =>  sourceArls.find((arl) => arl.Id === source.ParentId);
            // console.log('### clone', {arlValues, parent: sourceArlDictionary[source.ParentId], parentOverride: parentOverride()});

            let costAmountFromCalcChildren = 0;
            // is for calculation
            if (arlValues.Type !== AccountsReceivableLedgerTypeEnum.Group) {

                element.form.controls.childArlsCalculation.controls.forEach(calculationChildControl => {
                    const preCharge = this.ARLCalculationPreChargeByTypes.find(c => c.arlType === calculationChildControl.controls.Type.getRawValue())?.percentage || 0;
                    const cost = getARLCostAmountWithAllowance({CostAmount: calculationChildControl.controls.CostAmount.getRawValue(), CostAmountAllowance: calculationChildControl.controls.CostAmountAllowance.getRawValue()}) || 0;
                    console.log('### , preCharge, cost', preCharge, cost);
                    // source.CostAmount = cost + (cost * preCharge);
                    // source.CostAmountAllowance = null;
                    const ekWithPreCharge = cost + (cost * preCharge);
                    costAmountFromCalcChildren+= (ekWithPreCharge * (calculationChildControl.controls.Quantity.getRawValue() || 0));

                    calculationChildControl.patchValue({
                        CostAmount: ekWithPreCharge,
                        CostAmountAllowance: null,
                    })
                });
                // if (arlValues.InheritFromChildren) {
                //     // source.InheritFromChildren = false;
                //
                // }
            }

            element.form.controls.FixedPrices.markAsDirty();
            element.form.controls.BaseCost.markAsDirty();
            element.form.controls.BaseCostGross.markAsDirty();
            element.form.controls.SalaryBaseCost.markAsDirty();
            element.form.controls.InheritFromChildren.markAsDirty();
            element.form.controls.CostAmount.markAsDirty();
            element.form.patchValue({
                FixedPrices: true,
                BaseCost: preis,
                BaseCostGross: preisGross,
                SalaryBaseCost: preisSalaryPart,
                InheritFromChildren: false,
                CostAmount: arlValues.InheritFromChildren ? costAmountFromCalcChildren : arlValues.CostAmount,
            })
        }
    }
    onAbortGroupClick(element: arlTableData) {
        this.onAbortClick(element);
        // element.form.reset({
        //     name: element.group.name,
        // });
    }

    ngDoCheck(): void {
        this.ngDoCheck$.next();
    }

    protected readonly ARLTypeEnum = AccountsReceivableLedgerTypeEnum;

    onSetEntityId(
        data: arlTableData,
        id: number | null,
        m2s?: {
            supplierId: number;
            listPrice: number;
            cost: number;
            sellPrice: number;
            articleNumber?: string;
        },
    ) {
        const type = data.form.controls.Type.value;

        data.form.patchValue({
            ResourceId: type === AccountsReceivableLedgerTypeEnum.ResourceArl ? id : null,
            MaterialId: type === AccountsReceivableLedgerTypeEnum.MaterialArl ? id : null,
            JobSpecificationId: type === AccountsReceivableLedgerTypeEnum.EmployeeArl ? id : null,
        });
        data.form.controls.ResourceId.markAsDirty();
        data.form.controls.MaterialId.markAsDirty();
        data.form.controls.JobSpecificationId.markAsDirty();

        if (id) {
            switch (type) {
                case AccountsReceivableLedgerTypeEnum.ResourceArl:
                    firstValueFrom(data.resource$).then((resource) => {
                        if (resource?.Id === id) {
                            if (isNotNullOrUndefined(resource.MaxChargeRate) || isNotNullOrUndefined(resource.Cost)) {
                                if (isNotNullOrUndefined(resource.MaxChargeRate)) {
                                    const baseCost = parseFloat((resource.MaxChargeRate / 100).toFixed(4));
                                    data.form.controls.BaseCost.setValue(baseCost);
                                    data.form.controls.sonstigesBaseCost.setValue(baseCost);
                                    data.form.controls.BaseCost.markAsDirty();
                                    data.form.controls.sonstigesBaseCost.markAsDirty();
                                }
                                // hier kann nicht Ek und Vk gesetzt werden, da das feld Cost den kaufpreis der zu vermietenden maschiene darstellt
                                // if (isNotNullOrUndefined(resource.Cost)) {
                                //     const cost = parseFloat((resource.Cost / 100).toFixed(4));
                                //     data.form.controls.CostAmount.setValue(cost);
                                //     data.form.controls.CostAmount.markAsDirty();
                                // }
                                data.form.controls.SalaryBaseCost.setValue(0);
                                data.form.controls.SalaryBaseCost.markAsDirty();
                                this.recalculateSurcharge(data);
                            }
                            const resourceARLValues = resource.ARLValues;
                            if (resourceARLValues.QuantityTypeId) {
                                data.form.controls.QuantityTypeId.markAsDirty();
                                data.form.controls.QuantityTypeId.setValue(resourceARLValues.QuantityTypeId);
                            }
                            data.form.controls.BookingText.markAsDirty();
                            if (resourceARLValues.BookingText) {
                                data.form.controls.BookingText.setValue(resourceARLValues.BookingText);
                            } else {
                                data.form.controls.BookingText.setValue('');
                            }
                        }
                    });
                    break;
                case AccountsReceivableLedgerTypeEnum.MaterialArl:
                    console.log('material selected', data, id, m2s);
                    if (!id) {
                        break;
                    }
                    firstValueFrom(this.materialDataService.getMaterialById$(id)).then((material) => {
                        if (material?.Id === id) {
                            if (m2s) {
                                // firstValueFrom(this.materialToSupplierDataService.getMaterialToSupplierByMaterialId$(id)).then((m2s) => {
                                //     const m = m2s.find((m) => m.SupplierId === this.filterMaterialsByCustomerId);
                                //     if (!m) {
                                //         throw 'no materialToSupplier found, materialId: ' + id + ', supplierId: ' + this.filterMaterialsByCustomerId;
                                //     }
                                let cost = (m2s.cost || 0) / 100;
                                cost = financialRound(
                                    (1 + (this.ARLCalculationPreChargeByTypes.find(a => a.arlType === AccountsReceivableLedgerTypeEnum.MaterialArl)?.percentage || 0)) * cost,
                                    AccountsReceivableLedgerEntity.CostAmountDecimalPlaces + 2
                                );
                                const baseCost = (this.liDocumentType === LedgerImportDocumentTypes.Order ||
                                    this.liDocumentType === LedgerImportDocumentTypes.OrderConfirmation ||
                                    this.liDocumentType === LedgerImportDocumentTypes.ReturnDeliveryNote ||
                                    this.liDocumentType === LedgerImportDocumentTypes.DeliveryNote) ? cost : parseFloat(((this.useListPriceForNewMaterials ? m2s.listPrice || 0 : m2s.sellPrice || 0) / 100).toFixed(4));
                                data.form.controls.BaseCost.setValue(baseCost);
                                data.form.controls.CostAmount.setValue(cost);
                                data.form.controls.sonstigesBaseCost.setValue(baseCost);
                                data.form.controls.SalaryBaseCost.setValue(0);
                                data.form.controls.SupplierId.setValue(m2s.supplierId);

                                data.form.controls.SupplierId.markAsDirty();
                                data.form.controls.BaseCost.markAsDirty();
                                data.form.controls.CostAmount.markAsDirty();
                                data.form.controls.sonstigesBaseCost.markAsDirty();
                                data.form.controls.SalaryBaseCost.markAsDirty();
                                this.recalculateSurcharge(data);
                                // });
                            } else {
                                const baseCostCents = this.useListPriceForNewMaterials ? material.ListPrice : (this.liDocumentType === LedgerImportDocumentTypes.Order ||
                                    this.liDocumentType === LedgerImportDocumentTypes.OrderConfirmation ||
                                    this.liDocumentType === LedgerImportDocumentTypes.ReturnDeliveryNote ||
                                    this.liDocumentType === LedgerImportDocumentTypes.DeliveryNote) ? material.Cost : material.SellPrice;
                                if (isNotNullOrUndefined(baseCostCents) || isNotNullOrUndefined(material.Cost)) {
                                    if (isNotNullOrUndefined(baseCostCents)) {
                                        const baseCost = financialRound(baseCostCents / 100);
                                        data.form.controls.BaseCost.setValue(baseCost);
                                        data.form.controls.sonstigesBaseCost.setValue(baseCost);
                                        data.form.controls.BaseCost.markAsDirty();
                                        data.form.controls.sonstigesBaseCost.markAsDirty();
                                    }
                                    if (isNotNullOrUndefined(material.Cost)) {
                                        let cost = material.Cost / 100;
                                        cost = financialRound(
                                            (1 + (this.ARLCalculationPreChargeByTypes.find((a) => a.arlType === AccountsReceivableLedgerTypeEnum.MaterialArl)?.percentage || 0)) * cost,
                                            AccountsReceivableLedgerEntity.CostAmountDecimalPlaces + 2,
                                        );

                                        data.form.controls.CostAmount.setValue(cost);
                                        data.form.controls.CostAmount.markAsDirty();
                                    }
                                    data.form.controls.SalaryBaseCost.setValue(0);
                                    data.form.controls.SalaryBaseCost.markAsDirty();
                                    this.recalculateSurcharge(data);
                                }
                            }
                            const materialArlValues = material.ARLValues;
                            if (materialArlValues.QuantityTypeId) {
                                data.form.controls.QuantityTypeId.markAsDirty();
                                data.form.controls.QuantityTypeId.setValue(materialArlValues.QuantityTypeId);
                            }
                            data.form.controls.BookingText.markAsDirty();
                            if (m2s?.articleNumber || materialArlValues.BookingText) {
                                data.form.controls.BookingText.setValue(materialArlValues.BookingText || m2s?.articleNumber);
                            } else {
                                data.form.controls.BookingText.setValue('');
                            }
                        }
                    });
                    break;
                case AccountsReceivableLedgerTypeEnum.EmployeeArl:
                    if (id) {
                        firstValueFrom(this.store.select(getJobSpecificationById({ id }))).then((job) => {
                            if (job?.Id === id) {
                                if (isNotNullOrUndefined(job.Amount) || isNotNullOrUndefined(job.SellingPrice)) {
                                    if (isNotNullOrUndefined(job.Amount)) {
                                        let cost = job.Amount;
                                        cost = financialRound((1 + (this.ARLCalculationPreChargeByTypes.find(a => a.arlType === AccountsReceivableLedgerTypeEnum.EmployeeArl)?.percentage || 0)) * cost, AccountsReceivableLedgerEntity.CostAmountDecimalPlaces + 2);

                                        data.form.controls.CostAmount.setValue(cost);
                                    }
                                    if (isNotNullOrUndefined(job.SellingPrice)) {
                                        const baseCost = parseFloat(job.SellingPrice /* / 100*/.toFixed(4));
                                        data.form.controls.BaseCost.setValue(baseCost);
                                        data.form.controls.SalaryBaseCost.setValue(baseCost);
                                        data.form.controls.sonstigesBaseCost.setValue(0);
                                    }
                                    if (data.form.value.BaseCost) {
                                        this.recalculateSurcharge(data);
                                    } else {
                                        this.recalculateBaseCost(data);
                                    }
                                }
                                if (job.QuantityTypeId) {
                                    firstValueFrom(this.store.select(getQuantityTypes)).then((quantityTypes) => {
                                        const minuteType = quantityTypes.find((qt) => qt.Name === QuantityTypeNames.Minutes);
                                        const hourType = quantityTypes.find((qt) => qt.Name === QuantityTypeNames.Hours || qt.Name === QuantityTypeNames.Hours2 || qt.Name === QuantityTypeNames.Hours3 || qt.Name === QuantityTypeNames.Hours4);
                                        if ([minuteType.Id, hourType.Id].includes(data.form.controls.QuantityTypeId.getRawValue()) && data.form.value.Quantity && data.form.controls.QuantityTypeId.getRawValue() !== job.QuantityTypeId) {
                                            if (job.QuantityTypeId === minuteType.Id) {
                                                data.form.controls.Quantity.setValue(financialRound(data.form.value.Quantity * 60, QUANTITY_MAX_DECIMAL_PLACES));
                                            } else {
                                                data.form.controls.Quantity.setValue(financialRound(data.form.value.Quantity / 60, QUANTITY_MAX_DECIMAL_PLACES));
                                            }
                                        }
                                        data.form.controls.QuantityTypeId.setValue(job.QuantityTypeId);

                                        if (this.forceQuantityTypeIdForEmployeeArls && this.forceQuantityTypeIdForEmployeeArls !== job.QuantityTypeId) {
                                            if ([minuteType.Id, hourType.Id].includes(job.QuantityTypeId)) {
                                                switchHourMinute(this.forceQuantityTypeIdForEmployeeArls, data.form, minuteType.Id, hourType.Id);
                                            }
                                        }
                                    });
                                }
                            }
                        });
                    }
                    break;
            }
        }
    }

    protected readonly ResourcePageMeta = ResourcePageMeta;

    protected  async onBidderClick(rowData: arlTableData) {
        const supplierRes = await firstValueFrom(this.dialog.open<SelectSupplierDialogComponent, SelectSupplierDialogData, SelectSupplierDialogReturnData>(SelectSupplierDialogComponent, {
            data: {
                disableDropDown: rowData.form.controls.Information.disabled,
                supplierId: rowData.form.value.SupplierId,
                header: "Bieter",
                showCheckbox: false,
                tooltip: "Das ändern oder entfernen des Bieters ändert keine Preise",
                showDeleteButton: !rowData.form.controls.Information.disabled,
            }
        }).afterClosed());
        if(!supplierRes.Confirmed){
            return;
        }

        if(supplierRes?.SupplierId){
            if(supplierRes.SupplierId === rowData.form.controls.SupplierId.value){
                return;
            }
            rowData.form.controls.SupplierId.setValue(supplierRes.SupplierId)
            rowData.form.controls.SupplierId.markAsDirty()
        }else{
            rowData.form.controls.SupplierId.setValue(null)
            rowData.form.controls.SupplierId.markAsDirty()
        }
        rowData.form.controls.ChangedAfterSelectedFromPriceComparison.setValue(true)
        rowData.form.controls.ChangedAfterSelectedFromPriceComparison.markAsDirty()
    }

    onPriceInformationClick(rowData: arlTableData) {
        if (rowData.form.value.MaterialId) {
            const showSupplierButton = /*(this.isOrder || this.isOffer) && */ !rowData.form.value.InheritFromChildren;
            const dialogRef = this.dialog.open<MaterialPriceDetailsPopupComponent, MaterialPriceDetailsPopupComponentDialogData, MaterialPriceDetailsPopupComponentDialogReturnData>(MaterialPriceDetailsPopupComponent, {
                ...MaterialPriceDetailsPopupComponent.DefaultConfig,
                data: {
                    materialId: rowData.form.value.MaterialId,
                    supplierId: this.filterMaterialsByCustomerId,
                    ledgerImportDocumentType: this.liDocumentType === LedgerImportDocumentTypes.Order ? LedgerImportDocumentTypes.Order : LedgerImportDocumentTypes.Offer,
                    showOtherDocumentType: false,
                    showOtherSuppliersList: true,
                    showSupplierButton,
                    // materialEKForm,
                },
            });
            // dialogRef.afterClosed().subscribe((result: number) => {
            //     if (result) {
            //         const form = this.arlFormDataService.getForm(rowData.entity.Id);
            //         form.controls.SupplierId.setValue(result);
            //         form.controls.SupplierId.markAsDirty();
            //     }
            // });
            if (showSupplierButton) {
                dialogRef.componentInstance.M2SChange.pipe(takeUntil(dialogRef.afterClosed())).subscribe((value) => {
                    let cost = isNotNullOrUndefined(value.Cost) ? value.Cost / 100 : null;
                    cost = financialRound((1 + (this.ARLCalculationPreChargeByTypes.find(a => a.arlType === AccountsReceivableLedgerTypeEnum.MaterialArl)?.percentage || 0)) * cost, AccountsReceivableLedgerEntity.CostAmountDecimalPlaces + 2);

                    if (rowData.form.controls.CostAmount.value !== cost) {
                        rowData.form.controls.CostAmount.setValue(cost);
                        rowData.form.controls.CostAmount.markAsDirty();
                        this.costChange(rowData);
                    }
                    const baseCost = this.useListPriceForNewMaterials
                        ? isNotNullOrUndefined(value.ListPrice)
                            ? financialRound(value.ListPrice / 100)
                            : null
                        : isNotNullOrUndefined(value.SellPrice)
                        ? financialRound(value.SellPrice / 100)
                        : null;
                    if (rowData.form.controls.BaseCost.value !== baseCost || rowData.form.controls.sonstigesBaseCost.value !== baseCost || rowData.form.controls.SalaryBaseCost.value !== 0) {
                        rowData.form.controls.BaseCost.setValue(baseCost);
                        rowData.form.controls.BaseCost.markAsDirty();
                        rowData.form.controls.sonstigesBaseCost.setValue(baseCost);
                        rowData.form.controls.sonstigesBaseCost.markAsDirty();
                        rowData.form.controls.SalaryBaseCost.setValue(0);
                        rowData.form.controls.SalaryBaseCost.markAsDirty();
                        this.baseCostChange(rowData);
                    }

                    if (rowData.form.controls.SupplierId.value !== value.SupplierId) {
                        rowData.form.controls.SupplierId.setValue(value.SupplierId);
                        rowData.form.controls.SupplierId.markAsDirty();
                    }
                });
            }
        }
    }

    onEmployeeQuantityTypeChange(value: number | null) {
        console.log(value);
        if (value) {
            this.setAllEmployeeArlQuantityTypes(value);
        }
    }
    async setAllEmployeeArlQuantityTypes(qType: number) {
        const arls = await firstValueFrom(this.arlDataService.selectAllArlsDict());
        const quantityTypes = await firstValueFrom(this.store.select(getQuantityTypes));
        const minuteType = quantityTypes.find((qt) => qt.Name === QuantityTypeNames.Minutes);
        const hourType = quantityTypes.find((qt) => qt.Name === QuantityTypeNames.Hours || qt.Name === QuantityTypeNames.Hours2 || qt.Name === QuantityTypeNames.Hours3 || qt.Name === QuantityTypeNames.Hours4);

        const ids = this.arlIds.map((arlId) => this.arlFormDataService.getChildIds(arlId, true)).flat();
        ids.forEach((arlId) => {
            let form = this.arlFormDataService.getForm(arlId);
            if (!form) {
                this.arlFormDataService.setFormByEntity(arls[arlId], arls);
                form = this.arlFormDataService.getForm(arlId);
            }
            if (form.value.Type === AccountsReceivableLedgerTypeEnum.EmployeeArl) {
                switchHourMinute(qType, form, minuteType.Id, hourType.Id);
            }
            if (form.value.childArlsCalculation?.length) {
                form.controls.childArlsCalculation.controls.forEach((form) => {
                    if (form.value.Type === AccountsReceivableLedgerTypeEnum.EmployeeArl) {
                        switchHourMinuteCalc(qType, form, minuteType.Id, hourType.Id);
                    }
                });
            }
        });
    }

    protected readonly BreakpointObserverService = BreakpointObserverService;

    dragStarted(event: CdkDragStart) {
        if (this.isInvalidDragEvent) {
            document.dispatchEvent(new Event('mouseup'));
        }
    }

    onAllowanceClick(element: arlTableData<any>) {
        this.arlTableService.openAllowanceDialog({
            arlAllowanceFormArray: element.form.controls.BaseCostAllowances,
        });
    }
    onChargeClick(element: arlTableData<any>) {
        this.arlTableService.openChargeDialog({
            arlChargeFormArray: element.form.controls.BaseCostAllowances,
        });
    }
    onChargeByTypeClick(element: arlTableData<any>) {
        this.arlTableService.openChargeByTypeDialog({
            arlChargeFormArray: element.form.controls.BaseCostAllowances,
        });
    }
    onChargeOverrideClick(element: arlTableData<any>) {
        this.arlTableService.openChargeOverrideDialog(element.form, this.aRLCalculationPreCharge);
    }

    private setOptionalParents(form: arlTableDataArlForm) {
        if (form.value?.ParentId) {
            const formParent = this.arlFormDataService.getForm(form.value.ParentId);
            if (formParent.controls.IsOptional.value !== false) {
                formParent.controls.IsOptional.setValue(false);
                formParent.controls.IsOptional.markAsDirty();
            }
            this.setOptionalParents(formParent);
        }
    }
    private setCrossedOutParents(form: arlTableDataArlForm) {
        if (form.value?.ParentId) {
            const formParent = this.arlFormDataService.getForm(form.value.ParentId);
            if (formParent.controls.CrossedOut.value !== false) {
                formParent.controls.CrossedOut.setValue(false);
                formParent.controls.CrossedOut.markAsDirty();
            }
            this.setCrossedOutParents(formParent);
        }
    }

    onToggleOptional(element: arlTableData<any>) {
        element.form.controls.IsOptional.setValue(!element.form.value.IsOptional);
        if (element.form.value.IsOptional) {
            const childIds = this.arlFormDataService.getChildIds(element.form.value.Id);
            if (childIds.length) {
                childIds.forEach((childId) => {
                    const form = this.arlFormDataService.getForm(childId);
                    if (!form.value.IsOptional) {
                        form.controls.IsOptional.markAsDirty();
                        form.controls.IsOptional.setValue(true);
                    }
                });
            }
        } else {
            if (element.form.value.ParentId) {
                const form = this.arlFormDataService.getForm(element.form.value.ParentId);
                if (form.value.IsOptional) {
                    form.controls.IsOptional.markAsDirty();
                    form.controls.IsOptional.setValue(false);
                }
                this.setOptionalParents(form);
            }
        }
        element.form.controls.IsOptional.markAsDirty();
    }

    onToggleCrossedOut(element: arlTableData<any>) {
        element.form.controls.CrossedOut.setValue(!element.form.value.CrossedOut);
        if (element.form.value.CrossedOut) {
            const childIds = this.arlFormDataService.getChildIds(element.form.value.Id);
            if (childIds.length) {
                childIds.forEach((childId) => {
                    const form = this.arlFormDataService.getForm(childId);
                    if (!form.value.CrossedOut) {
                        form.controls.CrossedOut.setValue(true);
                        form.controls.CrossedOut.markAsDirty();
                    }
                });
            }
        } else {
            if (element.form.value.ParentId) {
                const form = this.arlFormDataService.getForm(element.form.value.ParentId);
                if (form.value.CrossedOut) {
                    form.controls.CrossedOut.setValue(false);
                    form.controls.CrossedOut.markAsDirty();
                }
                this.setCrossedOutParents(form);
            }
        }
        element.form.controls.CrossedOut.markAsDirty();
    }

    private financialRound(value) {
        // return parseFloat(parseFloat(value).toFixed(2));
        return financialRound(parseFloat(value));
    }

    onLohnChange(v: number, element: arlTableData<any>) {
        const value = v ? this.financialRound(v) : 0;

        element.form.controls.BaseCost.setValue(this.financialRound(value + (element.form.controls.sonstigesBaseCost.value || 0)));
        element.form.controls.BaseCost.markAsDirty();
        if (this.syncing) return;
        this.syncing = true;
        element.form.controls.BaseCostGross.setValue(financialRound(element.form.controls.BaseCost.value * (element.form.controls.Tax.value / 100 + 1))); // Nicht in LV aufrufen
        this.syncing = false;
        console.log('recalculateSurcharge 1');
        this.recalculateSurcharge(element);
    }
    onQuantityTypeChange(element: arlTableData<any>, newValue: number | null){

        element.form.controls.QuantityTypeId.markAsDirty();
        element.form.controls.QuantityTypeId.setValue(newValue);
        if (!isNotNullOrUndefined(element.form.controls.SurchargeOverride.getRawValue()) && !element.form.controls.FixedPrices.getRawValue()) {
            this.recalculateBaseCost(element);
        }
        if(element.form.controls.childArlsCalculation.value.length > 0) {
           // element.form.controls.childArls.setValue(element.form.controls.childArls.value)
            const formArray = element.form.controls.childArlsCalculation as FormArray;
            formArray.controls.forEach((group: FormGroup) => {
                group.controls.CostAmount.updateValueAndValidity({emitEvent: true})
            });
        }
    }

    async onSonstigeChange(v: number, element: arlTableData<any>) {
        const value = v ? this.financialRound(v) : 0;
        // await firstValueFrom(element.baseCostsWithAllowanceCharges$).then((baseCostsWithAllowanceCharges) => {
        //     console.log("sonstigesChange", baseCostsWithAllowanceCharges)
        // })
        // console.log("sonstigesChange", element) //Dadurch ist skipRecalculateSurcharge schon wieder false und diese werden neu berechnet. Dadurch wird das Zuschlagfeld was grade vom User bearbeitet wird wieder überschriben.

        const newValue = this.financialRound(value + (element.form.value.SalaryBaseCost || 0));
        if (newValue !== element.form.value.BaseCost) {
            element.form.controls.BaseCost.setValue(newValue);
            element.form.controls.BaseCost.markAsDirty();
        }
        if (this.syncing) return;
        this.syncing = true;
        element.form.controls.BaseCostGross.setValue(financialRound(element.form.controls.BaseCost.value * (element.form.controls.Tax.value / 100 + 1))); // Nicht in LV aufrufen
        this.syncing = false;
        console.log('recalculateSurcharge 2');
        this.recalculateSurcharge(element);
    }

    protected readonly getErrorMessage = getErrorMessage;

    public refresh(): void {
        this.allreadyCalculated = false;
        let tempIds = [...this.arlIds];

        const uniqueIds = new Set(tempIds);

        tempIds.forEach((arlId) => {
            const childIds = this.arlFormDataService.getChildIds(arlId);
            uniqueIds.add(arlId);
            childIds.forEach((id) => uniqueIds.add(id));
        });

        this.store
            .select(getAccountsReceivableLedgersByIds({ ids: Array.from(uniqueIds) }))
            .pipe(take(1))
            .subscribe((arlData) => {
                if (!arlData) {
                    console.warn('No ARLs found.');
                    return;
                }
                const arlDataForms = arlData.map((arl) => ({
                    selectedArl: arl,
                    form: this.arlFormDataService.getForm(arl.Id),
                }));
                arlDataForms.forEach(({ selectedArl, form }) => {
                    if (form) {
                        form.patchValue({
                            BaseCost: selectedArl.BaseCost,
                            Quantity: selectedArl.Quantity,
                            SalaryBaseCost: selectedArl.SalaryBaseCost,
                            CostAmount: selectedArl.CostAmount,
                        });
                    } else {
                        console.warn(`Form for ARL ID ${selectedArl.Id} not found.`);
                    }
                });
                this.recalculateAllSurcharge(
                    // arlDataForms.map((s) => s.form),
                    // this.ARLCalculationPreChargeByTypes,
                    // this.aRLCalculationPreCharge,
                );
                this.bookingPositionTable?.renderRows();
            });
    }
    async recalculateAllSurcharge(): Promise<void> {
        // const arlForms = rootArlForms.length ? await firstValueFrom(this.arlFormDataService.getChildren$(rootArlForms.map((f) => f.getRawValue().Id))) : [];
        const arlTableData = await firstValueFrom(this.tableData$);
        // console.warn('recalculateAllSurcharge');
        // const tabledata = await firstValueFrom(this.tableData$);

        arlTableData.forEach((td) => {
            if (determineIfIsArlTableDataOrGroupEnd(td) && isBookingPositionTypeEnum(td.form.controls.Type.getRawValue())) {
                // this.skipRecalculateBaseCost = true;
                this.recalculateSurcharge(td);
                // this.skipRecalculateBaseCost = false;
            }
        });
    }
    onToggleStartOnNewPage(element: arlTableData<any>) {
        element.form.controls.StartOnNewPage.setValue(!element.form.value.StartOnNewPage);
        element.form.controls.StartOnNewPage.markAsDirty();
    }
    // private skipRecalculateBaseCost = false;
    // private skipRecalculateSurcharge = false;
    //
    // async recalculateAllSurcharge() {
    //     console.warn('recalculateAllSurcharge');
    //     const tabledata = await firstValueFrom(this.tableData$);
    //     tabledata.forEach((rowData) => {
    //         if (determineIfIsArlTableDataOrGroupEnd(rowData)) {
    //             if (rowData.entity.isBookingPosition) {
    //                 this.skipRecalculateBaseCost = true;
    //                 this.recalculateSurcharge(rowData);
    //                 this.skipRecalculateBaseCost = false;
    //             }
    //         }
    //     });
    // }

    async recalculateBaseCost(rowData: arlTableData<any>) {
        var qTypes = await firstValueFrom(this.store.select(getQuantityTypeDictionary))
        this.arlTableService.recalculateBaseCost(rowData.form, /*this.ARLCalculationPreChargeByTypes,*/ this.aRLCalculationPreCharge, /*this.defaultSurcharges,*/ rowData.surchargePercentForm.value, qTypes);
        // if (this.skipRecalculateBaseCost) {
        //     this.skipRecalculateBaseCost = false;
        //     return;
        // }
        // if (!rowData.form.value.CostAmount || rowData.form.value.InheritFromChildren) {
        //     return;
        // }
        // console.warn('recalculateBaseCost');
        //
        // let percentFactor = 1 + (rowData.surchargePercentForm.value || 0) / 100;
        // console.log('xuzegfo', percentFactor, rowData);
        // const typePreCharge = this.ARLCalculationPreChargeByTypes.find((c) => c.arlType === rowData.form.value.Type);
        // const globalPreCharge = this.aRLCalculationPreCharge;
        //
        // if (typePreCharge?.percentage) {
        //     percentFactor = percentFactor * (1 + typePreCharge.percentage);
        // }
        // if (globalPreCharge) {
        //     percentFactor = percentFactor * (1 + globalPreCharge);
        // }
        //
        // const vk = (rowData.form.value.CostAmount || 0) * percentFactor;
        // let salaryVK = (rowData.form.value.BaseCost ? (rowData.form.value.SalaryBaseCost || 0) / rowData.form.value.BaseCost : 0) * vk;
        // if (!rowData.form.value.BaseCost && rowData.form.value.Type === AccountsReceivableLedgerTypeEnum.EmployeeArl) {
        //     salaryVK = vk;
        // }
        // this.skipRecalculateSurcharge = true;
        // rowData.form.patchValue(
        //     {
        //         BaseCost: this.financialRound(vk),
        //         SalaryBaseCost: this.financialRound(salaryVK),
        //     },
        //     { emitEvent: true },
        // );
        // this.skipRecalculateSurcharge = true;
        // rowData.form.controls.sonstigesBaseCost.setValue(this.financialRound(this.financialRound(vk) - this.financialRound(salaryVK)), { emitEvent: false });
        // this.skipRecalculateSurcharge = false;
        // console.log({ vk, salaryVK, costAmount: rowData.form.value.CostAmount, percentFactor });
    }
    recalculateSurcharge(rowData: arlTableData<any>) {
        this.arlTableService.recalculateSurcharge(rowData.form, /*this.ARLCalculationPreChargeByTypes,*/ this.aRLCalculationPreCharge, rowData.surchargePercentForm);
        if(rowData.form.controls.PriceComparisonId.value && !rowData.form.controls.PriceComparisonId.dirty){
            rowData.form.controls.ChangedAfterSelectedFromPriceComparison.setValue(true)
        }
        // if (this.skipRecalculateSurcharge) {
        //     this.skipRecalculateSurcharge = false;
        //     return;
        // }
        // console.warn('recalculateSurcharge');
        // const typePreCharge = this.ARLCalculationPreChargeByTypes.find((c) => c.arlType === rowData.form.value.Type);
        // const globalPreCharge = this.aRLCalculationPreCharge;
        //
        // const v = rowData.form.getRawValue();
        //
        // if (v.CostAmount && v.BaseCost) {
        //     this.skipRecalculateBaseCost = true;
        //     let diff = 1 + ((v.BaseCost || 0) / v.CostAmount - 1);
        //     if (typePreCharge?.percentage) {
        //         diff = diff / (1 + typePreCharge.percentage);
        //     }
        //     if (globalPreCharge) {
        //         diff = diff / (1 + globalPreCharge);
        //     }
        //     rowData.surchargePercentForm.setValue(this.financialRound((diff - 1) * 100), { emitEvent: false });
        //     this.skipRecalculateBaseCost = false;
        // }
    }
    // async recalculateAllBaseCost() {
    //     console.warn('recalculateAllBaseCost');
    //     const tabledata = await firstValueFrom(this.tableData$);
    //     tabledata.forEach((rowData) => {
    //         if (determineIfIsArlTableDataOrGroupEnd(rowData)) {
    //             this.skipRecalculateSurcharge = true;
    //             this.recalculateBaseCost(rowData);
    //             this.skipRecalculateSurcharge = false;
    //         }
    //     });
    // }
    //todo ggf auslagern und auch in LV Kalkulation aufrufen

    baseCostChange(rowData: arlTableData<any>) {
        if (this.syncing) return;
        this.syncing = true;
        rowData.form.controls.BaseCostGross.setValue(financialRound(rowData.form.controls.BaseCost.value * (rowData.form.controls.Tax.value / 100 + 1))); // Nicht in LV aufrufen
        this.syncing = false;
        console.log('recalculateSurcharge 3');
        this.recalculateSurcharge(rowData);
    }

    quantityChange(rowData: arlTableData<any>) {
        this.useArlSeparateSalaryBaseCost$.pipe(take(1)).subscribe((use) => {
            if (use) {
                this.baseCostChange(rowData);
            }
        });
    }

    baseCostGrossChange(rowData: arlTableData<any>) {
        if (this.syncing) return;
        this.syncing = true;
        rowData.form.controls.BaseCost.setValue(financialRound(rowData.form.controls.BaseCostGross.value / (rowData.form.controls.Tax.value / 100 + 1))); // Nicht in LV aufrufen
        this.syncing = false;
    }

    public syncing = false;

    protected syncCostAmountAndBaseCost: boolean | null = null;
    syncCostAmountAndBaseCostSub$ = this.LiDocumentType$.subscribe(docType => {
        this.syncCostAmountAndBaseCost = docType === LedgerImportDocumentTypes.Order ||
            docType === LedgerImportDocumentTypes.OrderConfirmation ||
            docType === LedgerImportDocumentTypes.ReturnDeliveryNote ||
            docType === LedgerImportDocumentTypes.DeliveryNote;
    })
    syncOrderCosts(element: arlTableData<any>, inputValue: number, changeFrom: string) {
        if (this.syncing || (!element.form.controls.CostAmount.dirty) && changeFrom === "changeFromCostAmount") return;

        this.syncing = true;

        const value = this.financialRound(inputValue ?? 0);


        if (changeFrom === "changeFromCostAmount"){
            element.surchargePercentForm.setValue(0);
        }


            if (changeFrom != 'changeFromLohn' && changeFrom != 'changeFromSonstiges' && (element.surchargePercentForm.value ?? 0) == 0) {
                if (element.form.controls.SalaryBaseCost.value == 0) {
                    element.form.controls.sonstigesBaseCost.setValue(value);
                } else if (element.form.controls.sonstigesBaseCost.value == 0) {
                    element.form.controls.SalaryBaseCost.setValue(value);
                } else {
                    const salary = element.form.controls.SalaryBaseCost.value;
                    const sonstiges = element.form.controls.sonstigesBaseCost.value;


                    const total = financialRound(salary + sonstiges);
                    if (total > 0) {
                        const factor = value / total;
                        const newSalary = financialRound(salary * factor);
                        const newSonstiges = financialRound(value - newSalary);

                        element.form.controls.SalaryBaseCost.setValue(newSalary);
                        element.form.controls.sonstigesBaseCost.setValue(newSonstiges);
                    }
                }

            }

    if (changeFrom != 'changeFromCostAmount' && (element.surchargePercentForm.value ?? 0) == 0) {
                switch (changeFrom) {
                    case "changeFromSonstiges":
                        element.form.controls.CostAmount.setValue(financialRound(value + (element.form.controls.SalaryBaseCost.value || 0)));
                        break;
                    case "changeFromLohn":
                        element.form.controls.CostAmount.setValue(financialRound(value + (element.form.controls.sonstigesBaseCost.value || 0)));
                        break;
                    default:
                        element.form.controls.CostAmount.setValue(financialRound(value))
                        break;
                }
            }
            if (changeFrom != 'changeFromBaseCost' ) {
                switch (changeFrom) {
                    case "changeFromSonstiges":
                        element.form.controls.BaseCost.setValue(financialRound(value + (element.form.controls.SalaryBaseCost.value || 0)));
                        break;
                    case "changeFromLohn":
                        element.form.controls.BaseCost.setValue(financialRound(value + (element.form.controls.sonstigesBaseCost.value || 0)));
                        break;
                    default:
                        element.form.controls.BaseCost.setValue(financialRound(value));
                        break;
                }
            }

        element.form.controls.sonstigesBaseCost.markAsDirty();
        element.form.controls.CostAmount.markAsDirty();
        element.form.controls.BaseCost.markAsDirty();
        element.form.controls.BaseCostGross.setValue(financialRound(element.form.controls.BaseCost.value * (element.form.controls.Tax.value / 100 + 1)));
        this.recalculateSurcharge(element);
        this.syncing = false;
    }

    //todo ggf auslagern und auch in LV Kalkulation aufrufen
    costChange(rowData: arlTableData<any>) {
        console.log('recalculateSurcharge 4');
        this.recalculateSurcharge(rowData);
    }
    //todo ggf auslagern und auch in LV Kalkulation aufrufen
    costBlur(rowData: arlTableData<any>) {
        if (!rowData.form.value.BaseCost && rowData.surchargePercentForm.value) {
            this.recalculateBaseCost(rowData);
        }
    }

    async surchargePercentChange(rowData: arlTableData<any>, value: number | null) {
        if (isNotNullOrUndefined(rowData.form.controls.SurchargeOverride.getRawValue())) {
            rowData.form.controls.SurchargeOverride.markAsDirty();
            rowData.form.controls.SurchargeOverride.setValue(value);
            // if (isNotNullOrUndefined(value)) {
            //     return;
            // }
        }

        rowData.surchargePercentForm.markAsDirty();
        rowData.surchargePercentForm.setValue(value);

        this.arlTableService.skipRecalculateSurcharge = true;
        this.syncing = true;
        const qTypes = await firstValueFrom(this.store.select(getQuantityTypeDictionary))
        this.arlTableService.recalculateBaseCost(rowData.form, /*this.ARLCalculationPreChargeByTypes,*/ this.aRLCalculationPreCharge,/* this.defaultSurcharges,*/ rowData.surchargePercentForm.value, qTypes);
        this.arlTableService.skipRecalculateSurcharge = false;
        this.syncing = false;
    }

    async onCopyClick(element: arlTableData<AccountsReceivableLedgerEntity>) {
        const rows = await firstValueFrom(this.tableData$);

        const index = await this.userSelectTableRowIndex(rows.indexOf(element));

        if (index != null) {
            this.LS.startLoading('copy-arls-in-li', { dialogMessage: 'Abrechnungsposition wird kopiert' });
            const rows = await firstValueFrom(this.tableData$);
            const getCalcZuschlFromParentArlId = (parentArlId: number) => {
                const ro = rows.find((r) => determineIfIsArlTableDataOrGroupEnd(r) && r.entity.Id === parentArlId)
                return ro && determineIfIsArlTableDataOrGroupEnd(ro) ? ro.arlTableCalculationPositionHelper?.zuschlaege : undefined;
            };
            const defaultTax = await firstValueFrom(this.store.select(getDefaultVat));
            try {
                const Newarl = await this.arlDataService.duplicateArlWithChildren(
                    element.form.value,
                    getCalcZuschlFromParentArlId,
                    defaultTax,
                    this.AddARLDefaultValues.ledgerImportId,
                );
                if (this._itemNumbersLocked){
                    this.allreadyCalculated = false;
                }
                await this.addArlsToTable([Newarl[0]], index);
            } catch (error) {
                console.error(error);
            }

            this.LS.endLoading('copy-arls-in-li');
        }
    }
    async onMoveClick(element: arlTableData<AccountsReceivableLedgerEntity> | groupEndPlaceholder) {
        if (this._disabled || this._itemNumbersLocked) {
            return;
        }
        // var arlCalcItem = [...(await firstValueFrom(this.dataSource.data$))];
        const rows = await firstValueFrom(this.tableData$);

        let index = await this.userSelectTableRowIndex(rows.indexOf(element));

        if (index != null) {
            let currentIndex: number;
            if (determineIfIsArlTableDataOrGroupEnd(element)) {
                currentIndex = rows.findIndex((row) => determineIfIsArlTableDataOrGroupEnd(row) && row.entity.Id === element.entity.Id);
            } else {
                currentIndex = rows.findIndex((row) => !determineIfIsArlTableDataOrGroupEnd(row) && row.groupId === element.groupId);
            }

            if (index > currentIndex) {
                index--;
            }
            await this.moveItemInArlArray(currentIndex, index, element);
        }
    }

    protected readonly AccountsReceivableLedgerTypeEnum = AccountsReceivableLedgerTypeEnum;
    protected readonly isNotNullOrUndefined = isNotNullOrUndefined;

    updateQuantityByQuantityHistory(form: arlTableDataArlForm) {
        arlFormUpdateQuantityByQuantityHistory(form);
    }
    onQuantityHistorySubmit(rowData: arlTableData<AccountsReceivableLedgerEntity>) {
        rowData.form.controls.QuantityHistory.push(
            getARLQuantityHistoryForm({
                quantityDelta: rowData.addQuantityHistoryForm.value,
                quantityDeltaFormula: '',
                date: new Date(),
            }),
        );
        this.updateQuantityByQuantityHistory(rowData.form);
        rowData.addQuantityHistoryForm.reset();
    }

    editQuantityHistory(rowData: arlTableData<AccountsReceivableLedgerEntity>) {
        this.dialog
            .open<QuantityHistoryModalComponent, QuantityHistoryModalComponentDialogData, QuantityHistoryModalComponentDialogReturnData>(QuantityHistoryModalComponent, {
                ...QuantityHistoryModalComponent.DefaultConfig,
                data: {
                    quantityHistoryForm: rowData.form.controls.QuantityHistory,
                },
            })
            .afterClosed()
            .subscribe(() => {
                this.updateQuantityByQuantityHistory(rowData.form);
            });
    }
    canDropAtPosition = (index: number, drag: CdkDrag, drop: CdkDropList) => {
        if(!this._itemNumbersLocked){
            return true;
        }else if (typeof drag.data !== 'string'){
            return false;
        }

        const data = drop.data;
        index -= 1
        if(index === -1){
            return false;
        }

        if (index >= data.length) {
            return true;
        }
        const target = data[index];

        return !this.determineIfIsArlTableDataOrGroupEnd(target);
    };





    protected readonly LedgerImportDocumentTypes = LedgerImportDocumentTypes;
    protected readonly AccountsReceivableLedgerEntity = AccountsReceivableLedgerEntity;

    public async setAllCalculationZuschlInPercent(arlType: AccountsReceivableLedgerTypeEnum, surcharge: number) {
        const rows = await firstValueFrom(this.tableData2$);
        rows.forEach(row => {
            if (determineIfIsArlTableDataOrGroupEnd(row) && row.arlTableCalculationPositionHelper) {
                row.arlTableCalculationPositionHelper.setZuschlInPercent(arlType, surcharge);
            }
        });
    }
    private setMultiselectActive(val: boolean, emitEvent = true) {
        if (val === this._multiselectActive) {
            return;
        }
        this.selection.clear();
        this._multiselectActive = val;
        if (emitEvent) {
            this.multiselectActiveChange.emit(val);
        }
    }
    public multiselectMarkOptional(optional: boolean) {
        this.selection.selected
            .map(arlId => this.arlFormDataService.getForm(arlId))
            .filter(form => form.controls.IsOptional.getRawValue() !== optional)
            .forEach(form => {
                form.controls.IsOptional.markAsDirty();
                form.controls.IsOptional.setValue(optional);
            });
        // this.selection.clear();
        this.setMultiselectActive(false);
        // this.selectionDataChanged$.next();
    }
    public multiselectMarkCrossedOut(crossed: boolean) {
        this.selection.selected
            .map(arlId => this.arlFormDataService.getForm(arlId))
            .filter(form => form.controls.CrossedOut.getRawValue() !== crossed)
            .forEach(form => {
                form.controls.CrossedOut.markAsDirty();
                form.controls.CrossedOut.setValue(crossed);
            });
        // this.selection.clear();
        this.setMultiselectActive(false);
        // this.selectionDataChanged$.next();
    }
    public async multiselectMarkFrozen(freeze: boolean) {
        const tableData = await firstValueFrom(this.tableData$);
        this.selection.selected
            .map(arlId => this.arlFormDataService.getForm(arlId))
            .filter(form => form.controls.FixedPrices.getRawValue() !== freeze)
            .forEach(form => {
                this.onToggleFixedPrice(tableData.find(td => {
                    return determineIfIsArlTableDataOrGroupEnd(td) && td.entity.Id === form.controls.Id.getRawValue();
                }) as arlTableData<AccountsReceivableLedgerEntity>);
            });
        // this.selection.clear();
        // this.selectionDataChanged$.next();
        this.setMultiselectActive(false);
    }
    public async multiselectSplit() {
        await this.splitPositions(this.selection.selected);
    }
    protected async splitPositions(arlIds: number[]) {
        if (!arlIds?.length) {
            return;
        }
        const selectedArlForms = arlIds.map(arlId => this.arlFormDataService.getForm(arlId));
        if (selectedArlForms.some(f => f.controls.childArlsCalculation.length === 0)) {
            console.error('Cannot split ARLs withoud calculationChildARLs');
            return;
        }

        const startIndex = await this.userSelectTableRowIndex();
        if (startIndex == null) {
            return;
        }

        if (selectedArlForms.some(f => f.controls.childArlsCalculation.controls.some(c => !c.controls.Id.getRawValue()))) {
            console.log('arlForm has no Id, submitting calculation arls');
            await this.SubmitCalculationArls();
        }

        const rows = await firstValueFrom(this.tableData2$);

        // neue formControls anlegen
        selectedArlForms.forEach(arlForm => {
            const row: arlTableData<AccountsReceivableLedgerEntity> = rows.find(r => determineIfIsArlTableDataOrGroupEnd(r) && r.entity.Id === arlForm.controls.Id.getRawValue()) as arlTableData<AccountsReceivableLedgerEntity>;
            arlForm.controls.childArlsCalculation.controls.forEach(arlCalcForm => {
                if (!arlCalcForm.controls.Id.getRawValue()) {
                    // this.arlDataService.addArls([
                    //     getCalculationArlCreatePayloadFromForm(
                    //         arlCalcForm,
                    //         false,
                    //         arlCalcForm.controls.Id.getRawValue(),
                    //         calculationArlGetBaseCostFromFormValue(arlCalcForm, )
                    //     )
                    // ])
                    // da die preisermittlung hier zu kompliziert ist werden die Kalkulierten positionen komplett gespeichert falls eine noch neu ist
                    throw new Error('arlCalcForm has no Id');
                }
                const baseCost = calculationArlGetBaseCostFromFormValue(arlCalcForm, row.arlTableCalculationPositionHelper.zuschlaege);
                const tax = this.AddARLDefaultValues.tax;
                this.arlFormDataService.setFormByCalculationArlForm(
                    arlCalcForm,
                    {
                        childrenVisible: false,
                        InheritFromChildren: false,
                        ARLIds: [],
                        ZuschlaegeResourcen: null,
                        ZuschlaegeMaterials: null,
                        ZuschlaegeDefault: null,
                        ZuschlaegeEmployee: null,
                        ZuschlaegeExternalService: null,
                        ZuschlaegeOther: null,
                        Longtext: '',
                        ShowLongtext: false,
                        Tax: tax,
                        AlreadyPayed: null,
                        Date: null,
                        SalaryBaseCost: null, // todo
                        StartOnNewPage: false,
                        sonstigesBaseCost: baseCost,
                        BaseCostAllowances: [],
                        ShowQuantityHistory: false,
                        UseQuantityHistory: false,
                        QuantityHistory: [],
                        lvCalculation: {
                            minutes: null,
                            SoEk: null,
                            SoAntEk: null,
                            GEK: null,
                            FlEk: null,
                            PartieHEur: null,
                            SoEkRabatt: null,
                        },
                        PriceComparisonId: null,
                        ChangedAfterSelectedFromPriceComparison: false,
                        Gaps: [],
                        FixedPrices: true,
                    },
                    new FormArray<arlTableDataArlForm>([]),
                    new FormArray<calculationArlFormGroup>([]),
                    {
                        BaseCost: baseCost,
                        BaseCostGross: financialRound(baseCost * (1 + tax / 100)),
                    }
                );
            });
        });

        const arlDict = await firstValueFrom(this.arlDataService.selectAllArlsDict());
        const array = await firstValueFrom(this.tableData2$);
        let index = startIndex;
        selectedArlForms.forEach((arlForm) => {
            arlForm.controls.childArlsCalculation.controls.forEach((childArlForm) => {
                this.addArlToArray(array, arlDict[childArlForm.controls.Id.getRawValue()], index);
                index++;
                this.calculationArlFormDataService.deleteForm(childArlForm.controls.Id.getRawValue());

            });
            arlForm.patchValue({
                ARLIds: [],
                InheritFromChildren: false,

                Type: AccountsReceivableLedgerTypeEnum.Text,
                BaseCost: 0,
                BaseCostGross: 0,
                CostAmount: 0,
                SalaryBaseCost: 0,
                FixedPrices: false,
            });
            arlForm.controls.childArlsCalculation.clear();
        })

        this.setMultiselectActive(false);
    }
    public async multiselectMerge() {
        if (this.selection.selected.length < 2) {
            return;
        }
        const selectedArlForms = this.selection.selected.map(arlId => this.arlFormDataService.getForm(arlId));
        if (selectedArlForms.some(f => f.controls.childArlsCalculation.length > 0 || f.controls.childArls.length > 0)) {
            console.error('Cannot merge ARLs with childARLs');
            return;
        }


        // neue überposition anlegen
        const [newMainArl] = await this.arlDataService.addArls([{
            ...this.AddARLDefaultValues,
            itemNumber: AccountsReceivableLedgerEntity.autogenerateItemNumber,
            arlIds: this.selection.selected,
            inheritFromChildren: true,
        }]);

        console.log('newMainArl', newMainArl);
        // alte arls anpassen
        const previousParentIds: number[] = [];
        selectedArlForms.forEach(f => {
            if (f.controls.ParentId.getRawValue()) {
                previousParentIds.push(f.controls.ParentId.getRawValue());
            }
            const newForm = this.calculationArlFormDataService.setFormByArlForm(f,
                {
                    IsVisible: false,
                    IndividuallyCostCalculation: true,
                    CostAmountAllowance: null,
                },
                {}
            );

            newForm.controls.ParentId.setValue(newMainArl.Id);
        });
        // neue Arl Form setzen
        const arlDict = await firstValueFrom(this.arlDataService.selectAllArlsDict());
        this.arlFormDataService.setFormByEntity(newMainArl, arlDict);


        await this.removeArlsFromTable(this.selection.selected);
        const array = await firstValueFrom(this.tableData2$);
        const index = await this.userSelectTableRowIndex();

        this.addArlToArray(array, newMainArl, index);
        this.selection.selected.forEach(id => this.arlFormDataService.deleteForm(id))
        this.setMultiselectActive(false);
    }
    public multiselectDelete() {
        this.DeleteClick.emit(this.selection.selected);
        // this.selection.clear()
        this.setMultiselectActive(false);
    }

    public async multiselectSelectAll(checked: boolean) {
        if (checked) {
            const selectable = await firstValueFrom(this.selectableTableData$);
            this.selection.setSelection(...selectable.map(s => s.entity.Id));
        } else {
            this.selection.clear();
        }
    }

    protected multiselectSelect(checked: boolean, rowData: arlTableData<AccountsReceivableLedgerEntity>) {
        const toSelect = [rowData.entity.Id];
        let childFormsValues = rowData.form.controls.childArls.value;
        while (childFormsValues.length > 0) {
            childFormsValues.forEach(c => {
                if (checked !== this.selection.isSelected(c.Id)) {
                    toSelect.push(c.Id)
                }
            });
            childFormsValues = childFormsValues.map(c => c.childArls).flat();
        }
        if (checked) {
            this.selection.select(...toSelect);
        } else {
            this.selection.deselect(...toSelect);
        }
    }

    public async multiselectCopy() {
        const rows = await firstValueFrom(this.tableData$);
        const index = await this.userSelectTableRowIndex();

        if (index != null) {
            this.LS.startLoading('copy-arls-in-li', { dialogMessage: 'Abrechnungsposition wird kopiert' });
            const getCalcZuschlFromParentArlId = (parentArlId: number) => {
                const ro = rows.find((r) => determineIfIsArlTableDataOrGroupEnd(r) && r.entity.Id === parentArlId)
                return ro && determineIfIsArlTableDataOrGroupEnd(ro) ? ro.arlTableCalculationPositionHelper?.zuschlaege : undefined;
            };
            const defaultTax = await firstValueFrom(this.store.select(getDefaultVat));
            try {
                const parentSelection = this.selection.selected.filter((arlId) => !this.selection.selected.includes(this.arlFormDataService.getForm(arlId).controls.ParentId.getRawValue()));
                const Newarls = await Promise.all(parentSelection
                    .sort((a,b) => rows.findIndex(r => determineIfIsArlTableDataOrGroupEnd(r) && r.entity.Id === a) - rows.findIndex(r => determineIfIsArlTableDataOrGroupEnd(r) && r.entity.Id === b))
                    .map(id => this.arlDataService.duplicateArlWithChildren(this.arlFormDataService.getForm(id).getRawValue(), getCalcZuschlFromParentArlId, defaultTax, this.AddARLDefaultValues.ledgerImportId))
                );
                if(this._itemNumbersLocked){
                    this.allreadyCalculated = false;
                }
                await this.addArlsToTable(Newarls.flat(), index);
                this.setMultiselectActive(false);
            } catch (error) {
                console.error(error);
            }

            this.LS.endLoading('copy-arls-in-li');
        }
    }

    private async userSelectTableRowIndex(initialSelectedIndex?: number) {
        const rows = await firstValueFrom(this.tableData$);

        return await firstValueFrom(this.dialog
            .open<ArlPositionDialogComponent, ArlPositionDialogComponentDialogData, ArlPositionDialogComponentDialogReturnData>(ArlPositionDialogComponent, {
                width: '40vw',
                data: {
                    Array: rows,
                    AllowOnlyLastPositionInGroup: false,// ItemNumbersFrozen: this._itemNumbersLocked, Dialog shows only Options at the end of Groups no longe needed for default arl-table
                    initialSelectedIndex: initialSelectedIndex,
                },
            })
            .afterClosed());
    }
    insertTemplate(form: FormControl<string>,
                   textarea?: HTMLTextAreaElement | null,) {
        addTemplate(this.dialog, form, textarea);
    }

    protected readonly invoiceEditorAutoScrollSpeed = invoiceEditorAutoScrollSpeed;
}
